import "core-js/modules/es6.set";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _logLevelToNumericVal, _TermsOfServicePathna, _PrivacyPolicyPathnam, _ApiLanguages;

import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/esnext.aggregate-error.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { __rest, __awaiter } from 'tslib';
import stringify from 'json-stringify-safe';
import { serializeError } from 'serialize-error';
import UAParser from '@amplitude/ua-parser-js';
import axios from 'axios';
import { v4 } from 'uuid';
import Cookies from 'js-cookie';
import fetchRetry from 'fetch-retry';
import jwt_decode from 'jwt-decode';
var LogLevel;

(function (LogLevel) {
  LogLevel["LOG"] = "LOG";
  LogLevel["DEBUG"] = "DEBUG";
  LogLevel["INFO"] = "INFO";
  LogLevel["WARN"] = "WARN";
  LogLevel["ERROR"] = "ERROR";
  LogLevel["FATAL"] = "FATAL";
})(LogLevel || (LogLevel = {}));

var CommonEventIds;

(function (CommonEventIds) {
  CommonEventIds[CommonEventIds["FetchResponseIsNotOk"] = 9995] = "FetchResponseIsNotOk";
  CommonEventIds[CommonEventIds["FetchFailedError"] = 9996] = "FetchFailedError";
  CommonEventIds[CommonEventIds["BrowserExtensionsUnhandledError"] = 9997] = "BrowserExtensionsUnhandledError";
  CommonEventIds[CommonEventIds["UnstructuredError"] = 9998] = "UnstructuredError";
  CommonEventIds[CommonEventIds["UnhandledError"] = 9999] = "UnhandledError";
})(CommonEventIds || (CommonEventIds = {}));
/** @module Enums */

/** typedoc */


var ApplicationEnum;

(function (ApplicationEnum) {
  ApplicationEnum["Artist"] = "Artist";
  ApplicationEnum["Auth0"] = "Auth0";
  ApplicationEnum["DesktopV2"] = "DesktopV2";
  ApplicationEnum["GuestSite"] = "GuestSite";
  ApplicationEnum["Core"] = "Core";
  ApplicationEnum["Library"] = "Library";
  ApplicationEnum["Projects"] = "Projects";
  ApplicationEnum["Billing"] = "Billing";
  ApplicationEnum["Account"] = "Account";
  ApplicationEnum["Dashboard"] = "Dashboard";
  ApplicationEnum["Distribution"] = "Distribution";
  ApplicationEnum["RootApp"] = "RootApp";
  ApplicationEnum["SamplesIngestionWizard"] = "SamplesIngestionWizard";
  ApplicationEnum["SamplesMarketplace"] = "SamplesMarketplace";
  ApplicationEnum["SamplesPlugin"] = "SamplesPlugin";
  ApplicationEnum["ServicesMarketplace"] = "ServicesMarketplace";
  ApplicationEnum["Web"] = "Web";
  ApplicationEnum["Sessions"] = "Sessions";
  ApplicationEnum["PluginsMarketplace"] = "PluginsMarketplace";
  ApplicationEnum["Messages"] = "Messages";
  ApplicationEnum["ProfileSetup"] = "ProfileSetup";
  ApplicationEnum["Chromatic"] = "Chromatic";
  ApplicationEnum["Network"] = "Network";
  ApplicationEnum["Profile"] = "Profile";
  ApplicationEnum["SynchroArtsApp"] = "SynchroArtsApp";
  ApplicationEnum["SynchroArtsGuestSite"] = "SynchroArtsGuestSite";
})(ApplicationEnum || (ApplicationEnum = {}));

var Languages;

(function (Languages) {
  Languages["English"] = "en";
  Languages["French"] = "fr";
  Languages["German"] = "de";
  Languages["Italian"] = "it";
  Languages["Japanese"] = "ja";
  Languages["Portuguese"] = "pt";
  Languages["Spanish"] = "es";
})(Languages || (Languages = {}));

var DefaultLanguage = Languages.English;
var InternalErrorEnum;

(function (InternalErrorEnum) {
  InternalErrorEnum[InternalErrorEnum["nonNullExpected"] = -1001] = "nonNullExpected";
})(InternalErrorEnum || (InternalErrorEnum = {}));

var MfeApplicationEnum;

(function (MfeApplicationEnum) {
  MfeApplicationEnum["CoreMfe"] = "core-mfe";
  MfeApplicationEnum["LibraryMfe"] = "library-mfe";
  MfeApplicationEnum["DashboardMfe"] = "dashboard-mfe";
  MfeApplicationEnum["ProjectsMfe"] = "projects-mfe";
  MfeApplicationEnum["LegacyMfe"] = "legacy-mfe";
  MfeApplicationEnum["SessionsMfe"] = "sessions-mfe";
  MfeApplicationEnum["DistributionMfe"] = "distribution-mfe";
  MfeApplicationEnum["AccountMfe"] = "account-mfe";
  MfeApplicationEnum["BillingMfe"] = "billing-mfe";
  MfeApplicationEnum["PluginsMfe"] = "plugins-mfe";
  MfeApplicationEnum["NetworkMfe"] = "network-mfe";
  MfeApplicationEnum["ProfileMfe"] = "profile-mfe";
  MfeApplicationEnum["SamplesMfe"] = "samples-mfe";
  MfeApplicationEnum["NetworkAngularMfe"] = "network-angular-mfe";
})(MfeApplicationEnum || (MfeApplicationEnum = {}));

var ProjectsCallSourceTypesEnum;

(function (ProjectsCallSourceTypesEnum) {
  ProjectsCallSourceTypesEnum["BellNotification"] = "BellNotification";
  ProjectsCallSourceTypesEnum["ProjectsLister"] = "ProjectsLister";
  ProjectsCallSourceTypesEnum["NewProjectInProjectsLister"] = "NewProjectInProjectsLister";
  ProjectsCallSourceTypesEnum["ConfirmationLibraryToast"] = "ConfirmationLibraryToast";
  ProjectsCallSourceTypesEnum["NewProjectInLibrary"] = "NewProjectInLibrary";
  ProjectsCallSourceTypesEnum["ProjectAttachmentInMessages"] = "ProjectAttachmentInMessages";
  ProjectsCallSourceTypesEnum["InviteToProjectInMessages"] = "InviteToProjectInMessages";
  ProjectsCallSourceTypesEnum["ConfirmationMessagesToast"] = "ConfirmationMessagesToast";
  ProjectsCallSourceTypesEnum["ViewProjectInMessages"] = "ViewProjectInMessages";
  ProjectsCallSourceTypesEnum["ViewProjectInLearnSection"] = "ViewProjectInLearnSection";
})(ProjectsCallSourceTypesEnum || (ProjectsCallSourceTypesEnum = {}));

var ProjectPageQueryParams;

(function (ProjectPageQueryParams) {
  ProjectPageQueryParams["AssetId"] = "assetId";
  ProjectPageQueryParams["AnnotationId"] = "annotationId";
  ProjectPageQueryParams["ProjectTab"] = "projectTab";
  ProjectPageQueryParams["Source"] = "source";
  ProjectPageQueryParams["AssetTypesFilters"] = "types";
  ProjectPageQueryParams["MessageView"] = "messageView";
})(ProjectPageQueryParams || (ProjectPageQueryParams = {}));

var SubscriptionServiceOfferEnum;

(function (SubscriptionServiceOfferEnum) {
  SubscriptionServiceOfferEnum["Chromatic"] = "Chromatic";
  SubscriptionServiceOfferEnum["Distribution"] = "Distribution";
  SubscriptionServiceOfferEnum["Mastering"] = "Mastering";
  SubscriptionServiceOfferEnum["Samples"] = "Samples";
  SubscriptionServiceOfferEnum["Sessions"] = "Sessions";
  SubscriptionServiceOfferEnum["Bundles"] = "Bundles";
})(SubscriptionServiceOfferEnum || (SubscriptionServiceOfferEnum = {}));

var Locales;

(function (Locales) {
  Locales["en"] = "en-us";
  Locales["fr"] = "fr";
  Locales["de"] = "de";
  Locales["es"] = "es";
  Locales["ja"] = "ja";
  Locales["it"] = "it";
  Locales["pt"] = "pt";
})(Locales || (Locales = {}));
/** @module Enums */

/** typedoc */

/**
 *
 * Zero-decimal currencies (https://support.stripe.com/questions/which-zero-decimal-currencies-does-stripe-support)

 - BIF: Burundian Franc
 - CLP: Chilean Peso
 - DJF: Djiboutian Franc
 - GNF: Guinean Franc
 - JPY: Japanese Yen
 - KMF: Comorian Franc
 - KRW: South Korean Won
 - MGA: Malagasy Ariary
 - PYG: Paraguayan Guaraní
 - RWF: Rwandan Franc
 - VND: Vietnamese Đồng
 - VUV: Vanuatu Vatu
 - XAF: Central African Cfa Franc
 - XOF: West African Cfa Franc
 - XPF: Cfp Franc
 */


var ZeroDecimalCurrenciesEnum;

(function (ZeroDecimalCurrenciesEnum) {
  ZeroDecimalCurrenciesEnum["BIF"] = "BIF";
  ZeroDecimalCurrenciesEnum["DJF"] = "DJF";
  ZeroDecimalCurrenciesEnum["JPY"] = "JPY";
  ZeroDecimalCurrenciesEnum["KRW"] = "KRW";
  ZeroDecimalCurrenciesEnum["PYG"] = "PYG";
  ZeroDecimalCurrenciesEnum["VND"] = "VND";
  ZeroDecimalCurrenciesEnum["XAF"] = "XAF";
  ZeroDecimalCurrenciesEnum["XPF"] = "XPF";
  ZeroDecimalCurrenciesEnum["CLP"] = "CLP";
  ZeroDecimalCurrenciesEnum["GNF"] = "GNF";
  ZeroDecimalCurrenciesEnum["KMF"] = "KMF";
  ZeroDecimalCurrenciesEnum["MGA"] = "MGA";
  ZeroDecimalCurrenciesEnum["RWF"] = "RWF";
  ZeroDecimalCurrenciesEnum["VUV"] = "VUV";
  ZeroDecimalCurrenciesEnum["XOF"] = "XOF";
})(ZeroDecimalCurrenciesEnum || (ZeroDecimalCurrenciesEnum = {}));
/** @module Enums */

/** typedoc */

/**
 * dollar-sign currencies country codes (http://www.xe.com/symbols.php#section3)
 * - ARS: Argentina Peso
 * - AUD: Australia Dollar
 * - BSD: Bahamas Dollar
 * - BBD: Barbados Dollar
 * - BMD: Bermuda Dollar
 * - BND: Brunei Darussalam Dollar
 * - CAD: Canada Dollar
 * - KYD: Cayman Islands Dollar
 * - CLP: Chile Peso
 * - COP: Colombia Peso
 * - XCD: East Caribbean Dollar
 * - SVC: El Salvador Colon
 * - FJD: Fiji Dollar
 * - GYD: Guyana Dollar
 * - HKD: Hong Kong Dollar
 * - LRD: Liberia Dollar
 * - MXN: Mexico Peso
 * - NAD: Namibia Dollar
 * - NZD: New Zealand Dollar
 * - SGD: Singapore Dollar
 * - SBD: Solomon Islands Dollar
 * - SRD: Suriname Dollar
 * - TVD: Tuvalu Dollar
 * - USD: United States Dollar
 */


var DollarSignCurrenciesEnum;

(function (DollarSignCurrenciesEnum) {
  DollarSignCurrenciesEnum["ARS"] = "ARS";
  DollarSignCurrenciesEnum["AUD"] = "AUD";
  DollarSignCurrenciesEnum["BSD"] = "BSD";
  DollarSignCurrenciesEnum["BBD"] = "BBD";
  DollarSignCurrenciesEnum["BMD"] = "BMD";
  DollarSignCurrenciesEnum["BND"] = "BND";
  DollarSignCurrenciesEnum["CAD"] = "CAD";
  DollarSignCurrenciesEnum["KYD"] = "KYD";
  DollarSignCurrenciesEnum["CLP"] = "CLP";
  DollarSignCurrenciesEnum["COP"] = "COP";
  DollarSignCurrenciesEnum["XCD"] = "XCD";
  DollarSignCurrenciesEnum["SVC"] = "SVC";
  DollarSignCurrenciesEnum["FJD"] = "FJD";
  DollarSignCurrenciesEnum["GYD"] = "GYD";
  DollarSignCurrenciesEnum["HKD"] = "HKD";
  DollarSignCurrenciesEnum["LRD"] = "LRD";
  DollarSignCurrenciesEnum["MXN"] = "MXN";
  DollarSignCurrenciesEnum["NAD"] = "NAD";
  DollarSignCurrenciesEnum["NZD"] = "NZD";
  DollarSignCurrenciesEnum["SGD"] = "SGD";
  DollarSignCurrenciesEnum["SBD"] = "SBD";
  DollarSignCurrenciesEnum["SRD"] = "SRD";
  DollarSignCurrenciesEnum["TVD"] = "TVD";
  DollarSignCurrenciesEnum["USD"] = "USD";
})(DollarSignCurrenciesEnum || (DollarSignCurrenciesEnum = {}));

var AllowedErrorFieldsEnum;

(function (AllowedErrorFieldsEnum) {
  AllowedErrorFieldsEnum["code"] = "code";
  AllowedErrorFieldsEnum["name"] = "name";
  AllowedErrorFieldsEnum["message"] = "message";
  AllowedErrorFieldsEnum["severity"] = "severity";
  AllowedErrorFieldsEnum["httpCode"] = "httpCode";
  AllowedErrorFieldsEnum["status"] = "status";
  AllowedErrorFieldsEnum["url"] = "url";
  AllowedErrorFieldsEnum["falcorPaths"] = "falcorPaths";
  AllowedErrorFieldsEnum["fallbackState"] = "fallbackState";
  AllowedErrorFieldsEnum["line"] = "line";
  AllowedErrorFieldsEnum["column"] = "column";
  AllowedErrorFieldsEnum["sourceUrl"] = "sourceUrl";
  AllowedErrorFieldsEnum["detail"] = "detail";
  AllowedErrorFieldsEnum["stack"] = "stack";
})(AllowedErrorFieldsEnum || (AllowedErrorFieldsEnum = {}));

var AllowedExtraInfosFields;

(function (AllowedExtraInfosFields) {
  // Apollo Client properties
  AllowedExtraInfosFields["timeElapsed"] = "timeElapsed";
  AllowedExtraInfosFields["operationType"] = "operationType";
  AllowedExtraInfosFields["operationName"] = "operationName"; // Apollo Server properties

  AllowedExtraInfosFields["operationOwner"] = "operationOwner"; // Cloud Logger properties

  AllowedExtraInfosFields["clientIP"] = "clientIP";
  AllowedExtraInfosFields["details"] = "details";
  AllowedExtraInfosFields["request"] = "request";
  AllowedExtraInfosFields["response"] = "response"; // Flag to identify if the request is coming from the Samples MFE or legacy FE

  AllowedExtraInfosFields["isSamplesMfe"] = "isSamplesMfe";
})(AllowedExtraInfosFields || (AllowedExtraInfosFields = {}));

var faultyBrowserExtensions = ['https://js.intercomcdn.com/', 'fww.hieroglyphstwittering.com', 'zib.slakelegionary.com', 'pageantryundertakings.com', 'attacksspaghetti.com', 'journallingpercolates.com', 'jrc.withstandingheartwarming.com', 'nbz.deferringplateaus.com', 'demisedcolonnaded.com', 'akamaihd.net'];
var logLevelToNumericValueMap = (_logLevelToNumericVal = {}, _logLevelToNumericVal[LogLevel.LOG] = 0, _logLevelToNumericVal[LogLevel.DEBUG] = 1, _logLevelToNumericVal[LogLevel.INFO] = 2, _logLevelToNumericVal[LogLevel.WARN] = 3, _logLevelToNumericVal[LogLevel.ERROR] = 4, _logLevelToNumericVal[LogLevel.FATAL] = 5, _logLevelToNumericVal);

function getLogLevel(value) {
  return logLevelToNumericValueMap[value];
}

function isNil(value) {
  return value === null || value === undefined;
}

function isObject(value) {
  return typeof value === 'object';
}

function isError(value) {
  if (!value || !isObject(value)) {
    return false;
  }

  var tag = Object.prototype.toString.call(value);
  return tag === '[object Error]' || tag === '[object DOMException]' || typeof value.message === 'string' && typeof value.name === 'string';
}

function getError(firstParam) {
  var error = null;

  if (firstParam) {
    if (isError(firstParam)) {
      error = firstParam;
    }
  }

  return error;
}

function getLogLevelForError(error, actualLevel) {
  // Very simple for now
  // Later will handle some backend known codes, some 404, etc.
  if (error.status) {
    var isInternalError = Object.values(InternalErrorEnum).includes(error.status);

    if (isInternalError) {
      return LogLevel.DEBUG;
    }
  }

  return actualLevel;
}

function getRealLogLevel(args, level) {
  var firstParam = args.length > 2 ? args[2] : null; // Compute a new level based on potential error

  var error = getError(firstParam);
  return error ? getLogLevelForError(error, level) : level;
}

function shouldLogToProvider(level, config) {
  var minLevel = getLogLevel(config.minLevel);
  var logLevelEnabled = getLogLevel(level) >= minLevel;
  return config.enabled && logLevelEnabled;
}

function isClassLogEnable(className, level, moduleConfig, valueIfNotFound) {
  if (valueIfNotFound === void 0) {
    valueIfNotFound = true;
  }

  var classLevel = moduleConfig && moduleConfig[className];

  if (isNil(classLevel)) {
    return valueIfNotFound;
  }

  return getLogLevel(classLevel) <= getLogLevel(level);
}

function isExternalFatalError(level, eventId, error) {
  return level === LogLevel.FATAL && eventId === CommonEventIds.UnhandledError && isError(error) && typeof error.stack === 'string' && faultyBrowserExtensions.some(function (ex) {
    return error.stack.indexOf(ex) > -1;
  });
}

function prepareStructuredEvent(level, message, eventId, error, extraInfos, className) {
  // Convert error to an `Error` type if it's a string
  // In loggly, a property should always have the same type, otherwise it's not parsed
  if (typeof error === 'string') {
    error = new Error(error);
  } // Ensure error parameter is valid


  if (!isNil(error) && !isError(error) && !isObject(error)) {
    return {
      level: LogLevel.FATAL,
      className: className,
      eventId: CommonEventIds.UnstructuredError,
      message: '$log can\'t be called with invalid "error" parameter',
      error: undefined,
      extraInfos: {
        error: error
      }
    };
  } // Check if error is not from our code


  if (!isNil(error) && isExternalFatalError(level, eventId, error)) {
    return {
      level: LogLevel.WARN,
      className: className,
      eventId: CommonEventIds.BrowserExtensionsUnhandledError,
      message: 'Browser extensions unhandled error',
      error: error,
      extraInfos: undefined
    };
  }

  var serializedError = undefined;

  if (error) {
    serializedError = isError(error) ? serializeError(error) : {
      message: stringify(error)
    };
  }

  return {
    level: level,
    className: className,
    message: message,
    eventId: eventId,
    error: serializedError,
    extraInfos: isNil(extraInfos) ? undefined : extraInfos
  };
}

function prepareEvent(level, args, className) {
  var message = args[0];
  var eventId = args[1];
  var hasErrorArg = level === LogLevel.FATAL || level === LogLevel.WARN || level === LogLevel.ERROR;
  var error = hasErrorArg ? args[2] : undefined;
  var extraInfos = hasErrorArg ? args[3] : args[2];
  var shouldBeStructuredEvent = level === LogLevel.FATAL || level === LogLevel.WARN || level === LogLevel.ERROR;

  if (typeof message === 'string' && typeof eventId === 'number') {
    return prepareStructuredEvent(level, message, eventId, error, extraInfos, className);
  } else if (shouldBeStructuredEvent) {
    // pass all event args as extra information
    return prepareStructuredEvent(LogLevel.FATAL, "$log can't be called with those arguments", CommonEventIds.UnstructuredError, null, {
      eventArgs: JSON.stringify(args)
    }, className);
  } // TODO: Add EventId for all Info and Debug level logs


  var data = {
    level: level,
    className: className,
    message: message
  };
  var firstParam = args[1];

  if (firstParam) {
    var logDetails = firstParam;

    if (Array.isArray(logDetails)) {
      logDetails = {
        params: logDetails
      };
    } else {
      logDetails = {
        context: isObject(logDetails) ? stringify(logDetails) : logDetails
      };
    } // We create a new object to ensure 'message' will never be overwritten by logDetails one


    data = Object.assign(Object.assign({}, logDetails), data);
  }

  return data;
}

function isStructuredEvent(event) {
  return event.eventId !== undefined;
}
/**
 * Filter a provided Error object and return a new object with the allowed properties ONLY
 * Warning: We stringify each value to avoid busting Loggly max indexing capacity (500, but it index objects recursively)
 * @param error
 */


function filterErrorFields(error) {
  if (typeof error === 'string') {
    return {
      message: error
    };
  }

  var newErrorField = {};

  if (error.message) {
    newErrorField.message = stringify(error.message);
  } // Doing a try catch as `Object.keys` do not work for all browsers
  // if this fails rawError will still be sent to loggly
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys#Polyfill


  try {
    Object.keys(error).forEach(function (key) {
      if (Object.values(AllowedErrorFieldsEnum).includes(key)) {
        if (key === AllowedErrorFieldsEnum.detail) {
          if (error[key].line) {
            newErrorField['line'] = stringify(error[key].line);
          }

          if (error[key].column) {
            newErrorField['column'] = stringify(error[key].column);
          }

          if (error[key].sourceUrl) {
            newErrorField['sourceUrl'] = stringify(error[key].sourceUrl);
          }
        } else {
          newErrorField[key] = stringify(error[key]);
        }
      }
    });
  } catch (_a) {// do nothing it's just to avoid breaking older browsers when logging
  }

  return newErrorField;
}
/**
 * Filter provided AdditionalInfos object and return a new object with the allowed properties ONLY
 * Warning: We stringify each value to avoid busting Loggly max indexing capacity (500, but it index objects recursively)
 * @param ExtraInfos
 */


function filterUnallowedExtraInfosFields(ExtraInfos) {
  var newAdditionalInfos = {};

  try {
    Object.keys(ExtraInfos).forEach(function (key) {
      if (Object.values(AllowedExtraInfosFields).includes(key)) {
        if (key === AllowedExtraInfosFields.timeElapsed) {
          newAdditionalInfos['timeElapsed'] = ExtraInfos[key];
        } else {
          newAdditionalInfos[key] = typeof ExtraInfos[key] === 'string' ? ExtraInfos[key] : stringify(ExtraInfos[key]);
        }
      }
    });
  } catch (_a) {// do nothing it's just to avoid breaking older browsers when logging
  }

  return newAdditionalInfos;
}

var LogService =
/*#__PURE__*/
function () {
  function LogService(logger, config, callback, className) {
    if (callback === void 0) {
      callback = function callback() {};
    }

    this.logger = logger;
    this.config = config;
    this.callback = callback;
    this.className = className;
  } // region Public methods


  var _proto = LogService.prototype;

  _proto.getInstance = function getInstance(className) {
    var newClassName = this.className ? "" + this.className + this.config.separator + className : className;
    return new LogService(this.logger, this.config, this.callback, newClassName);
  };

  _proto.log = function log(message, eventId, extraArguments) {
    this.prepare(LogLevel.LOG).apply(null, arguments);
  };

  _proto.debug = function debug(message, eventId, extraArguments) {
    this.prepare(LogLevel.DEBUG).apply(null, arguments);
  };

  _proto.info = function info(message, eventId, extraArguments) {
    this.prepare(LogLevel.INFO).apply(null, arguments);
  };

  _proto.warn = function warn(message, eventId, error, extraArguments) {
    this.prepare(LogLevel.WARN).apply(null, arguments);
  };

  _proto.error = function error(message, eventId, _error, extraArguments) {
    this.prepare(LogLevel.ERROR).apply(null, arguments);
  };

  _proto.fatal = function fatal(message, eventId, error, extraArguments) {
    this.prepare(LogLevel.FATAL).apply(null, arguments);
  };

  _proto.isLevelEnabled = function isLevelEnabled(level) {
    return this.config.enabled && isClassLogEnable(this.className, level, this.config.module);
  } // endregion
  // region Private methods
  ;

  _proto.getLogFunction = function getLogFunction(level) {
    switch (level) {
      case LogLevel.INFO:
        return this.logger.info;

      case LogLevel.WARN:
        return this.logger.warn;

      case LogLevel.DEBUG:
        return this.logger.debug;

      case LogLevel.ERROR:
        return this.logger.error;

      case LogLevel.FATAL:
        return this.logger.error;

      case LogLevel.LOG:
        return this.logger.log;

      default:
        return this.logger.log;
      // Should never happen
    }
  };

  _proto.prepare = function prepare(level) {
    var _this = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (_this.className) {
        args[0] = "" + _this.className + _this.config.separator + args[0];
      }

      var newLevel = getRealLogLevel(args, level);

      if (!_this.isLevelEnabled(newLevel)) {
        return;
      }

      var event = prepareEvent(newLevel, args, _this.className);

      if (shouldLogToProvider(newLevel, _this.config.console)) {
        var eventId = isStructuredEvent(event) ? event.eventId : null;

        var fn = _this.getLogFunction(newLevel);

        var _a = event,
            _level = _a.level,
            _message = _a.message,
            _eventId = _a.eventId,
            extraParams = __rest(_a, ["level", "message", "eventId"]);

        var stack = extraParams && extraParams.error && extraParams.error.stack;

        if (_this.config.debug && stack) {
          // For debugging purpose, this will print original stack trace with source mapping
          console.error(stack);
        }

        fn.apply(null, [event.message, eventId, extraParams]);
      } // Callback if somebody want to deal with sent message


      _this.callback(event);
    };
  };

  return LogService;
}();
/**
 * Replaces LogService & LogglyService for Landr Clouds Apps
 * sending their logs to the STDOUT instead of sending them directly to loggly (BBFs, Lambdas...)
 */


var ConsoleLogService =
/*#__PURE__*/
function () {
  function ConsoleLogService(className, logConfig, version) {
    var _a;

    this.className = className;
    this.logConfig = logConfig;
    this.version = version;
    this.logFunctions = {};
    logConfig.stringify = (_a = logConfig.stringify) !== null && _a !== void 0 ? _a : true;
  }

  var _proto2 = ConsoleLogService.prototype;

  _proto2.getInstance = function getInstance(className, logConfig, version) {
    var newClassName = this.className ? "" + this.className + logConfig.separator + className : className;
    return new ConsoleLogService(newClassName, logConfig, version);
  };

  _proto2.log = function log(message, eventId, extraArguments) {
    this._log(LogLevel.LOG, message, eventId, extraArguments);
  };

  _proto2.debug = function debug(message, eventId, extraArguments) {
    this._log(LogLevel.DEBUG, message, eventId, extraArguments);
  };

  _proto2.info = function info(message, eventId, extraArguments) {
    this._log(LogLevel.INFO, message, eventId, extraArguments);
  };

  _proto2.warn = function warn(message, eventId, error, extraArguments) {
    this._log(LogLevel.WARN, message, eventId, extraArguments, error);
  };

  _proto2.error = function error(message, eventId, _error2, extraArguments) {
    this._log(LogLevel.ERROR, message, eventId, extraArguments, _error2);
  };

  _proto2.fatal = function fatal(message, eventId, error, extraArguments) {
    this._log(LogLevel.FATAL, message, eventId, extraArguments, error);
  };

  _proto2.isLevelEnabled = function isLevelEnabled(level) {
    return this.logConfig.enabled && Object.keys(LogLevel).indexOf(level) >= Object.keys(LogLevel).indexOf(this.logConfig.minLevel);
  };

  _proto2.getLogFunction = function getLogFunction(level) {
    if (!this.logFunctions[level]) {
      // eslint-disable-next-line no-console
      this.logFunctions[level] = this.isLevelEnabled(level) ? console.log : function () {};
    }

    return this.logFunctions[level];
  };

  _proto2._log = function _log(level, message, eventId, extraArguments, error) {
    var log = this.buildLog(level, message, eventId, extraArguments, error);
    this.getLogFunction(level).apply(null, [log]);
  };

  _proto2.buildLog = function buildLog(level, message, eventId, extraArguments, error) {
    var detailedError = error ? {
      error: filterErrorFields(error),
      errorRaw: typeof error !== 'string' ? stringify(error) : error
    } : {};
    var extraInfos = {
      extraInfos: filterUnallowedExtraInfosFields(extraArguments),
      extraInfosRaw: extraArguments ? stringify(extraArguments) : undefined
    };
    var extraInfosAllowedToRootLog = {
      userId: (extraArguments === null || extraArguments === void 0 ? void 0 : extraArguments.userId) || undefined,
      correlationId: (extraArguments === null || extraArguments === void 0 ? void 0 : extraArguments.correlationId) || undefined,
      consecutiveOccurrences: (extraArguments === null || extraArguments === void 0 ? void 0 : extraArguments.consecutiveOccurrences) || 0
    };
    /**
     * Make sure it returns a LogglyStructuredEvent so both logging stacks stay consistent
     */

    var log = Object.assign(Object.assign(Object.assign(Object.assign({
      level: level,
      eventId: eventId,
      message: this.formatMessage(message)
    }, extraInfosAllowedToRootLog), extraInfos), detailedError), {
      timestamp: new Date().toUTCString(),
      serviceKey: this.logConfig.serviceKey,
      deploymentKind: this.logConfig.deploymentKind,
      version: this.version,
      application: this.logConfig.application
    });
    return this.logConfig.stringify ? JSON.stringify(log) : log;
  };

  _proto2.formatMessage = function formatMessage(message) {
    return [this.className, message].join(this.logConfig.separator);
  };

  return ConsoleLogService;
}();

var LogglyService =
/*#__PURE__*/
function () {
  // eslint-disable-next-line @typescript-eslint/member-ordering
  function LogglyService(config, properties, $window, httpClient) {
    this.config = config;
    this.$window = $window;
    this.httpClient = httpClient;
    this.httpConfig = {
      headers: {
        'Content-Type': 'text/plain'
      }
    };
    this.savedLogs = {};
    this.savedLogsOccurrences = {}; // Set Loggly settings from CONFIG

    this.httpUrl = "https://logs-01.loggly.com/inputs/" + this.config.apiKey + "/tag/" + this.config.tags + "/";
    this.MAX_LOG_OCCURRENCES = this.config.maxBundleSize;
    this.httpClient = this.httpClient || axios.create(); // Compute default static properties

    this.defaultProperties = LogglyService.computeDefaultProperties(properties);
  }

  LogglyService.computeDefaultProperties = function computeDefaultProperties(properties) {
    if (!properties.userInfos) {
      try {
        properties.userInfos = new UAParser().getResult();
      } catch (e) {// Not able to parse user-agent - Nothing major.
      }
    }

    return Object.assign({
      consecutiveOccurrences: 0
    }, properties);
  }
  /**
   *  To be passed to the LogService Callback so it's called after calling the console logger
   * @param event - structured event provided by the LogService
   * @param extraParameters - Do not pass objects to deep as this params will not be sent to
   * loggly stringified (max field index can be hit) and skip type validation
   */
  ;

  var _proto3 = LogglyService.prototype;

  _proto3.send = function send(event, extraParameters) {
    if (extraParameters === void 0) {
      extraParameters = {};
    } // Ensure we are able to send


    if (!this.config.enabled || !this.config.apiKey || this.$window && !this.$window.navigator.onLine) {
      return;
    } // Ensure we are allowed to send


    var forceSendLogForClass = isClassLogEnable(event.className, event.level, this.config.forcedModule, false);

    if (!shouldLogToProvider(event.level, this.config) && !forceSendLogForClass) {
      return;
    }

    var logglyEvent = this.prepareLogglyEvent(Object.assign(Object.assign({}, event), extraParameters), this.defaultProperties);
    var previousLog = this.savedLogs[logglyEvent.level];
    var previousLogNbCalls = this.savedLogsOccurrences[logglyEvent.level] || 0;

    if (stringify(logglyEvent) === stringify(previousLog)) {
      // This log is identical to the previous one of the same level.
      previousLogNbCalls += 1;
      this.savedLogsOccurrences[logglyEvent.level] += 1;

      if (previousLogNbCalls < this.MAX_LOG_OCCURRENCES) {
        // We haven't reached the bundle size threshold : don't send the log.
        return;
      } else {
        // We hit the max log bundle size : reset the counter and send the log.
        this.savedLogsOccurrences[logglyEvent.level] = 0;
        return this.post(previousLog, previousLogNbCalls);
      }
    } else {
      this.savedLogs[logglyEvent.level] = logglyEvent;
      this.savedLogsOccurrences[logglyEvent.level] = 0;

      if (previousLogNbCalls > 0) {
        // This log ended the series of identical logs : send it along with the current log.
        return Promise.all([this.post(previousLog, previousLogNbCalls), this.post(logglyEvent)]);
      } else {
        // Normal non-identical log.
        return this.post(logglyEvent);
      }
    }
  };

  _proto3.post = function post(event, consecutiveOccurrences) {
    if (consecutiveOccurrences === void 0) {
      consecutiveOccurrences = 0;
    }

    var finalEvent = this.finalizeLogglyEvent(event, consecutiveOccurrences);
    return this.httpClient.post(this.httpUrl, finalEvent, this.httpConfig).catch(function () {
      // The request was blocked by client (e.g. uBlock extension).
      console.log('Could not send log to Loggly.');
    });
  }
  /**
   * Prepare a Loggly event with most of the properties we want to send to loggly
   * with the excaption of two that would not allow us to compare logs for similar occurences and batch them.
   * finalizeLogglyEvent() will take care of adding the missing properties.
   * @param event
   * @param logglyMandatoryProperties
   */
  ;

  _proto3.prepareLogglyEvent = function prepareLogglyEvent(event, logglyMandatoryProperties) {
    var updatedErrorFields = {};
    var updatedExtraInfosFields = {};
    var extraInfosAllowedToRootLog = {}; // We need to rework the error field as it sometimes contains so many properties that it breaks Loggly indexing.

    if (event.error) {
      // Filter out error fields to return only what we allow &
      // Add a stringified raw version so we always have access on Loggly for complete context and search
      updatedErrorFields = {
        error: filterErrorFields(event.error),
        errorRaw: typeof event.error === 'string' ? event.error : stringify(event.error)
      };
    } // We need to rework the extraInfos field as it sometimes could contains so many properties that it breaks Loggly indexing.


    var extraInfos = event.extraInfos;

    if (extraInfos) {
      // Filter out extraInfos fields to return only what we allow &
      // Add a stringified raw version so we always have access on Loggly for complete context and search
      updatedExtraInfosFields = {
        extraInfos: filterUnallowedExtraInfosFields(extraInfos),
        extraInfosRaw: stringify(extraInfos)
      }; // Override `userId` and `correlationId` if they are present in extraInfos

      if (extraInfos === null || extraInfos === void 0 ? void 0 : extraInfos.userId) {
        extraInfosAllowedToRootLog.userId = extraInfos.userId;
      }

      if (extraInfos === null || extraInfos === void 0 ? void 0 : extraInfos.correlationId) {
        extraInfosAllowedToRootLog.correlationId = extraInfos.correlationId;
      }
    }

    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, logglyMandatoryProperties), event), updatedErrorFields), updatedExtraInfosFields), extraInfosAllowedToRootLog), {
      timestamp: undefined
    });
  }
  /**
   * Allow to add the last information to a loggly event.
   * We do not want to add this information until the last moment to be able to compare the log occurences and be able to batch them.
   * @param event
   * @param consecutiveOccurrences
   */
  ;

  _proto3.finalizeLogglyEvent = function finalizeLogglyEvent(event, consecutiveOccurrences) {
    if (consecutiveOccurrences === void 0) {
      consecutiveOccurrences = 0;
    }

    return Object.assign(Object.assign({}, event), {
      timestamp: new Date().toISOString(),
      consecutiveOccurrences: consecutiveOccurrences
    });
  };

  return LogglyService;
}();

var SegmentLoader =
/*#__PURE__*/
function () {
  function SegmentLoader(windowObject) {
    this.disabled = false;
    this.isLoadedPromise = null;
    this.window = windowObject;

    if (typeof this.window === 'undefined') {
      this.disabled = true;
    } else {
      this.setupSnippet();
    }
  }
  /**
   * Load analytics
   *
   * Analytics might never load on browsers with Ad Blockers.
   * To prevent returing a promise that never resolves, this method will resolve after a timeout.
   *
   * Hence there are 3 scenarios:
   *  1. (Happy path) - Segment has finished loading in time, yay!
   *  2. (Ad Blockers) - Segment will never load
   *     ...this method will resolve after a timeout
   *  3. (Slow Connexions) - 6 seconds have passed and this method has resolved, but Segment is still loading
   *     ... this is not a problem
   *     ... future events will be put in the queue until Loading is truly finished
   *     ... 6 seconds is what it takes chrome to load the analytics on a Slow 3G connexion.
   *
   * @returns A promise that resolve when analytics are loaded, to a max of wait time 6 seconds.
   */


  var _proto4 = SegmentLoader.prototype;

  _proto4.load = function load(segmentWriteKey, options) {
    var _this2 = this;

    if (this.disabled) {
      return Promise.resolve();
    }

    this.isLoadedPromise = this.isLoadedPromise || new Promise(function (resolve) {
      if (!(options === null || options === void 0 ? void 0 : options.wrapper)) {
        _this2.window.analytics.load(segmentWriteKey);
      } else {
        options.wrapper(_this2.window.analytics).load(segmentWriteKey);
      }

      _this2.window.analytics.ready(function () {
        resolve();
      });
    });
    var timeoutPromise = new Promise(function (resolve) {
      setTimeout(resolve, 6000);
    });
    return Promise.race([this.isLoadedPromise, timeoutPromise]);
  }
  /**
   * This method is based on the Segment snippet (and converted to Typescript).
   * It asynchronously loads Segment, and creates a queue used until Segment is ready.
   */
  ;

  _proto4.setupSnippet = function setupSnippet() {
    // Create a queue, but don't obliterate an existing one!
    var analytics = this.window.analytics = this.window.analytics || [];
    /**
     * Return early if
     * - the analytics snippet is already on the page
     * - the analytics snippet was already invoked
     */

    if (analytics.initialize || analytics.invoked) {
      return;
    }

    var segmentDomain = this.window && this.window.location.host.match(/(-dev|-demo|-partner|local).landr.com$/g) ? 'cdn2-segment-dev.landr.com' : 'cdn2-segment.landr.com'; // Invoked flag, to make sure the snippet is never invoked twice.

    analytics.invoked = true; // A list of the methods in Segment's Analytics.js to stub.

    analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']; // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.

    analytics.factory = function (method) {
      return function () {
        // eslint-disable-next-line prefer-rest-params
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    }; // For each of our methods, generate a queueing stub.


    for (var _iterator = _createForOfIteratorHelperLoose(analytics.methods), _step; !(_step = _iterator()).done;) {
      var key = _step.value;
      analytics[key] = analytics.factory(key);
    } // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.


    analytics.load = function (key, options) {
      // Create an async script element based on your key.
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = "https://" + segmentDomain + "/snippet.js/v1/" + key + "/snippet.min.js"; // Insert our script next to the first script element.

      var first = document.getElementsByTagName('script')[0];

      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
      }

      analytics._loadOptions = options;
      analytics._cdn = "https://" + segmentDomain;
    }; // Add a version to keep track of what's in the wild.


    analytics.SNIPPET_VERSION = '4.1.0';
  };

  return SegmentLoader;
}();

var TransformMethods;

(function (TransformMethods) {
  TransformMethods[TransformMethods["JOIN"] = 0] = "JOIN";
  TransformMethods[TransformMethods["UPPERCASE"] = 1] = "UPPERCASE";
  TransformMethods[TransformMethods["LOWERCASE"] = 2] = "LOWERCASE";
})(TransformMethods || (TransformMethods = {}));

var userPropertiesMapping = {
  UserId: 'L - User Id',
  UserFirstName: 'L - User First Name',
  UserLastName: 'L - User Last Name',
  UserEmail: 'L - User Email',
  UserLanguage: 'L - User Language'
};

function getUserProperties(user) {
  return Object.entries(user).reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];

    if (Object.prototype.hasOwnProperty.call(userPropertiesMapping, key)) {
      acc[userPropertiesMapping[key]] = value;
    }

    return acc;
  }, {});
}
/**
 * This abstract service will be extended from the SegmentService that gets generated
 * by running the `setup-analytics` command.
 *
 * @export
 * @class AbstractSegmentService
 */


var AbstractSegmentService =
/*#__PURE__*/
function () {
  function AbstractSegmentService(config, windowObject) {
    this.disabled = false;
    this.segmentWriteKey = config.segmentWriteKey;
    this.window = windowObject;
    this.segmentLoader = new SegmentLoader(windowObject);

    if (typeof this.window === 'undefined') {
      this.disabled = true;
    }
  }
  /**
   * Load analytics
   *
   * Analytics might never load on browsers with Ad Blockers.
   * To prevent returing a promise that never resolves, this method will resolve after a timeout.
   *
   * Hence there are 3 scenarios:
   *  1. (Happy path) - Segment has finished loading in time, yay!
   *  2. (Ad Blockers) - Segment will never load
   *     ...this method will resolve after after a timeout
   *  3. (Slow Connexions) - 6 seconds have passed and this method has resolved, but Segment is still loading
   *     ... this is not a problem
   *     ... future events will be put in the queue until Loading is truly finished
   *     ... 6 seconds is what it takes chrome to load the analytics on a Slow 3G connexion.
   *
   * @returns A promise that resolve when analytics are loaded, to a max of wait time 6 seconds.
   */


  var _proto5 = AbstractSegmentService.prototype;

  _proto5.load = function load() {
    return this.segmentLoader.load(this.segmentWriteKey);
  };

  _proto5.identify = function identify(user, applicationProperties) {
    var _this3 = this;

    if (this.disabled || !this.window.analytics) {
      return;
    }

    this.window.analytics.ready(function () {
      var analyticsUser = _this3.window.analytics.user && _this3.window.analytics.user();

      var analyticsGroup = _this3.window.analytics.group && _this3.window.analytics.group();

      if (analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.traits) {
        analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.traits({});
      }

      if (analyticsGroup === null || analyticsGroup === void 0 ? void 0 : analyticsGroup.traits) {
        analyticsGroup === null || analyticsGroup === void 0 ? void 0 : analyticsGroup.traits({});
      }

      if (user) {
        _this3.window.analytics.identify(user.UserId, Object.assign(Object.assign({}, getUserProperties(user)), applicationProperties)); // Links anonymous identify for Chameleon to the identified user


        if (analyticsUser && analyticsUser.anonymousId) {
          _this3.window.analytics.alias(user.UserId, analyticsUser.anonymousId(), {
            integrations: {
              All: false,
              Chameleon: true
            }
          });
        }
      } else {
        // We only reset the user id in segment SDK. Anonymous identifies are not necessary. Amplitude doesn't need it, and we're
        // not willing to pay for Chameleon MAUs that includes anonymous users
        analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.id(null);
      }
    });
  };

  _proto5.reset = function reset() {
    if (this.disabled || !this.window.analytics) {
      return;
    }

    this.window.analytics.reset();

    if (this.window.analytics.user) {
      this.window.analytics.user().id(null);
    }
  } // eslint-disable-next-line @typescript-eslint/ban-types
  ;

  _proto5.page = function page(pageName, params) {
    if (params === void 0) {
      params = {};
    }

    if (this.disabled || !this.window.analytics) {
      return;
    }

    this.window.analytics.page(pageName, params);
  }
  /**
   * Method to handle transforming Amplitude event properties. In amplitude, you can decide to
   * transform an event property to lowercase, uppercase, or join array elements
   */
  ;

  _proto5.transform = function transform(method, value) {
    var result = value;

    switch (method) {
      case TransformMethods.JOIN:
        result = Array.isArray(result) ? result.join(', ') : result;
        break;

      case TransformMethods.LOWERCASE:
        result = Array.isArray(result) ? result.map(function (r) {
          return r.toLowerCase();
        }) : result.toLowerCase();
        break;

      case TransformMethods.UPPERCASE:
        result = Array.isArray(result) ? result.map(function (r) {
          return r.toUpperCase();
        }) : result.toUpperCase();
        break;
    }

    return result;
  } // eslint-disable-next-line @typescript-eslint/ban-types
  ;

  _proto5.track = function track(name, category, params, _temp) {
    var _this4 = this;

    if (params === void 0) {
      params = {};
    }

    var _ref2 = _temp === void 0 ? {} : _temp,
        gaLabel = _ref2.gaLabel,
        gaValue = _ref2.gaValue;

    if (this.disabled || !this.window.analytics) {
      return Promise.resolve();
    }

    var segmentParams = Object.assign({}, params); // Add analytics for GA. Segment expects a special param `label` or `value` so it can transfer it back to GA

    if (gaLabel) {
      var propertyValue = params[gaLabel];
      segmentParams['label'] = Array.isArray(propertyValue) ? this.transform(TransformMethods.JOIN, propertyValue) : propertyValue;
    }

    if (gaValue) {
      segmentParams['value'] = params[gaValue];
    }

    return new Promise(function (resolve) {
      _this4.window.analytics.track(name, Object.assign({
        'Event Category': category
      }, segmentParams), {}, resolve);
    });
  };

  return AbstractSegmentService;
}();

var UUIDRegex = /([0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12})/g;

function getSanitizedPageName(pathname) {
  return pathname.replace(UUIDRegex, ':id');
}

var AnalyticsPlatformName;

(function (AnalyticsPlatformName) {
  AnalyticsPlatformName["Desktop"] = "Desktop";
  AnalyticsPlatformName["Mobile"] = "Mobile";
  AnalyticsPlatformName["Plugin"] = "Plugin";
  AnalyticsPlatformName["Web"] = "Web";
})(AnalyticsPlatformName || (AnalyticsPlatformName = {}));

function getPlatformName(localWindow) {
  if (localWindow === void 0) {
    localWindow = window;
  }

  if (localWindow.isMobileAppWebView) {
    return AnalyticsPlatformName.Mobile;
  }

  if (localWindow.electronPreload) {
    return AnalyticsPlatformName.Desktop;
  }

  return AnalyticsPlatformName.Web;
}

var AnalyticsApplication;

(function (AnalyticsApplication) {
  AnalyticsApplication["Account"] = "Account";
  AnalyticsApplication["Chromatic"] = "Chromatic";
  AnalyticsApplication["Dashboard"] = "Dashboard";
  AnalyticsApplication["Distribution"] = "Distribution";
  AnalyticsApplication["Feedback"] = "Feedback";
  AnalyticsApplication["GuestSite"] = "Guest Site";
  AnalyticsApplication["Mastering"] = "Mastering";
  AnalyticsApplication["Messages"] = "Messages";
  AnalyticsApplication["Network"] = "Network";
  AnalyticsApplication["Plugins"] = "Plugins";
  AnalyticsApplication["Pricing"] = "Pricing";
  AnalyticsApplication["Profile"] = "Profile";
  AnalyticsApplication["Projects"] = "Projects";
  AnalyticsApplication["Samples"] = "Samples";
  AnalyticsApplication["Sessions"] = "Sessions";
  AnalyticsApplication["Platform"] = "Platform";
  AnalyticsApplication["Blog"] = "Blog";
  AnalyticsApplication["Learn"] = "Learn";
  AnalyticsApplication["SynchroArts"] = "SynchroArts";
})(AnalyticsApplication || (AnalyticsApplication = {}));
/**
 * See full documentation on Notion:
 * https://www.notion.so/landr/Convert-Integration-with-web-app-1db4e564d2644d3ca345c495b1c3caf4
 */


var ConvertExperimentLoader =
/*#__PURE__*/
function () {
  function ConvertExperimentLoader(windowObject) {
    this.experimentCallbacks = {};
    this.window = windowObject;

    if (this.window) {
      this.initialize();
    }
  }

  var _proto6 = ConvertExperimentLoader.prototype;

  _proto6.run = function run() {
    var _a, _b;

    if (!this.window) {
      return;
    }

    if ((_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.convert_done) {
      (_b = this.window._conv_q) === null || _b === void 0 ? void 0 : _b.push(['run', 'true']);
    }
  };

  _proto6.registerToExperimentUpdate = function registerToExperimentUpdate(experimentId, callback) {
    var _a;

    if (!this.window) {
      return;
    } // Notify right away


    (_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.push([this.notifyCallbackForExperiment(experimentId, callback)]); // Store callback for later call using async handler

    var registrationId = v4();
    this.experimentCallbacks[registrationId] = {
      experimentId: experimentId,
      callback: callback
    };
    return registrationId;
  };

  _proto6.unregisterToExperiment = function unregisterToExperiment(registrationId) {
    delete this.experimentCallbacks[registrationId];
  };

  _proto6.initialize = function initialize() {
    var _this5 = this;

    var _a; // Ensure we have a queue of events for first app loading
    // https://convert.elevio.help/en/articles/84994-react-redux-and-convert-experiences


    this.window._conv_q = this.window._conv_q || []; // As there is no way to unregister listeners. We should only register to `snippet.experiences_evaluated` in `initialize` method
    // and we will handle

    (_a = this.window._conv_q) === null || _a === void 0 ? void 0 : _a.push({
      what: 'addListener',
      params: {
        event: 'snippet.experiences_evaluated',
        handler: function handler() {
          var callbacksRegistered = Object.entries(_this5.experimentCallbacks);
          callbacksRegistered.forEach(function (_ref3) {
            var _ = _ref3[0],
                callbackRegistered = _ref3[1];

            _this5.notifyCallbackForExperiment(callbackRegistered.experimentId, callbackRegistered.callback);
          });
        }
      }
    });
  };

  _proto6.notifyCallbackForExperiment = function notifyCallbackForExperiment(experimentId, callback) {
    var _a, _b, _c, _d;

    if (((_b = (_a = this.window.convert) === null || _a === void 0 ? void 0 : _a.currentData) === null || _b === void 0 ? void 0 : _b.experiments) && ((_d = (_c = this.window.convert) === null || _c === void 0 ? void 0 : _c.currentData) === null || _d === void 0 ? void 0 : _d.experiments[experimentId])) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      var _this$window$convert$ = this.window.convert.currentData.experiments[experimentId],
          variation_id = _this$window$convert$.variation_id,
          variation_name = _this$window$convert$.variation_name;
      callback({
        variationId: variation_id.toString(),
        variationName: variation_name
      });
    } else {
      callback(null);
    }
  };

  return ConvertExperimentLoader;
}();
/**
 * This abstract service will be extended from the SegmentService that gets generated
 * by running the `setup-analytics` command.
 *
 * @export
 * @class AbstractSegmentService
 */


var AbstractSegmentServiceV2 =
/*#__PURE__*/
function () {
  function AbstractSegmentServiceV2(applicationName, windowObject, platformNameOverride) {
    this.disabled = false;
    this.applicationName = applicationName;
    this.segmentLoader = new SegmentLoader(windowObject);
    this.convertExperiment = new ConvertExperimentLoader(windowObject);
    this.window = windowObject;

    if (typeof this.window === 'undefined') {
      this.disabled = true;
    } else {
      if (platformNameOverride) {
        this.platformName = platformNameOverride;
      } else {
        this.platformName = getPlatformName(this.window);
      }

      this.subscribeToPageEvents();
    }

    this.setSegmentReadyPromise();
  }
  /**
   * Loads analytics snippet
   * @param segmentWriteKey
   */


  var _proto7 = AbstractSegmentServiceV2.prototype;

  _proto7.load = function load(segmentWriteKey, options) {
    return this.segmentLoader.load(segmentWriteKey, options ? {
      wrapper: options.consentWrapper
    } : undefined);
  }
  /**
   * Identifies the user's sessions (anonymous or logged in user)
   * @param userId
   * @param analyticsProperties a mix of auth state, reconciled data and platform provider data you can get using `getAnalyticsProperties`
   * @param userTraits
   */
  ;

  _proto7.identify = function identify(userId, analyticsProperties, userTraits) {
    if (userTraits === void 0) {
      userTraits = {};
    }

    return __awaiter(this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var analyticsUser, analyticsGroup;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.disabled || !this.window.analytics)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return this.segmentReadyPromise;

            case 4:
              analyticsUser = this.window.analytics.user && this.window.analytics.user();
              analyticsGroup = this.window.analytics.group && this.window.analytics.group();

              if (analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.traits) {
                analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.traits({});
              }

              if (analyticsGroup === null || analyticsGroup === void 0 ? void 0 : analyticsGroup.traits) {
                analyticsGroup === null || analyticsGroup === void 0 ? void 0 : analyticsGroup.traits({});
              }

              if (userId) {
                this.window.analytics.identify(userId, userTraits); // Links anonymous identify for Chameleon to the identified user

                if (analyticsUser && analyticsUser.anonymousId) {
                  this.window.analytics.alias(userId, analyticsUser.anonymousId(), {
                    integrations: {
                      Chameleon: true
                    }
                  });
                }

                this.sendSignedUpEventIfNecessary(analyticsProperties);
                this.sendLoggedInEventIfNecessary(analyticsProperties);
              } else {
                // We only reset the user id in segment SDK. Anonymous identifies are not necessary. Amplitude doesn't need it, and we're not
                // willing to pay for Chameleon MAUs that includes anonymous users
                analyticsUser === null || analyticsUser === void 0 ? void 0 : analyticsUser.id(null);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  _proto7.reset = function reset() {
    if (this.disabled || !this.window.analytics) {
      return;
    }

    this.window.analytics.reset();
  }
  /**
   *
   * @param pageLanguage
   * @param pageNameOverride should only be provided for apps with virtual routes like AngularJS
   * @param applicationNameOverride should ONLY be used by the legacy-mfe because it handles multiple application.
   */
  ;

  _proto7.page = function page(pageLanguage, pageNameOverride, applicationNameOverride) {
    return __awaiter(this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var pageName;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.disabled || !this.window.analytics)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return this.segmentReadyPromise;

            case 4:
              pageName = pageNameOverride ? pageNameOverride : getSanitizedPageName(this.window.location.pathname);
              this.window.analytics.page(pageName, {
                application_name: applicationNameOverride || this.applicationName,
                language: pageLanguage,
                platform: this.platformName,

                /**
                 * Manually set path and url to ensure they are always the same as the location's pathname and href.
                 * This is necessary because Segment defaults to the canonical url to set "path" and "url" in the page event properties.
                 *
                 * More context: https://github.com/LandrAudio/LANDR.Web.Core/pull/247
                 */
                path: this.window.location.pathname,
                url: this.window.location.href
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  } // eslint-disable-next-line @typescript-eslint/ban-types
  ;

  _proto7.track = function track(eventName, properties, applicationNameOverride) {
    return __awaiter(this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var _this6 = this;

      var timeoutPromise, trackPromise;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.disabled || !this.window.analytics)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", Promise.resolve());

            case 2:
              _context3.next = 4;
              return this.segmentReadyPromise;

            case 4:
              // In case ad blockers don't load segment, this will ensure it's not blocking code waiting for the promise
              timeoutPromise = new Promise(function (resolve) {
                setTimeout(resolve, 2000);
              });
              trackPromise = new Promise(function (resolve) {
                _this6.window.analytics.track(eventName, Object.assign(Object.assign({}, _this6.getDefaultTrackProperties(applicationNameOverride)), properties), {}, resolve);
              });
              return _context3.abrupt("return", Promise.race([trackPromise, timeoutPromise]));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  _proto7.getDefaultTrackProperties = function getDefaultTrackProperties(applicationNameOverride) {
    var _a, _b, _c, _d, _e, _f, _g;

    return {
      application_name: applicationNameOverride || this.applicationName,
      platform: this.platformName,
      page_language: (_a = this.window.landrAnalytics) === null || _a === void 0 ? void 0 : _a.currentPageProperties.language,
      page_name: (_b = this.window.landrAnalytics) === null || _b === void 0 ? void 0 : _b.currentPageProperties.name,
      page_path: (_c = this.window.landrAnalytics) === null || _c === void 0 ? void 0 : _c.currentPageProperties.path,
      page_referrer: (_d = this.window.landrAnalytics) === null || _d === void 0 ? void 0 : _d.currentPageProperties.referrer,
      page_search: (_e = this.window.landrAnalytics) === null || _e === void 0 ? void 0 : _e.currentPageProperties.search,
      page_title: (_f = this.window.landrAnalytics) === null || _f === void 0 ? void 0 : _f.currentPageProperties.title,
      page_url: (_g = this.window.landrAnalytics) === null || _g === void 0 ? void 0 : _g.currentPageProperties.url
    };
  };

  _proto7.subscribeToPageEvents = function subscribeToPageEvents() {
    var _this7 = this;

    var _a;

    if (this.disabled || !this.window.analytics) {
      return;
    } // Only one instance will subscribe to page events, the rest will use `this.window.currentPageProperties`


    if (!((_a = this.window.landrAnalytics) === null || _a === void 0 ? void 0 : _a.subscribedToPageEvents)) {
      // Set landrAnalytics data in window so other instances can access it
      this.window.landrAnalytics = {
        currentPageProperties: {
          language: 'en',
          name: '',
          path: '',
          referrer: '',
          search: '',
          title: '',
          url: ''
        },
        subscribedToPageEvents: true
      };
      this.window.analytics.on('page', function (_, __, pageProperties) {
        _this7.window.landrAnalytics.currentPageProperties = pageProperties;
      });
    }
  };

  _proto7.setSegmentReadyPromise = function setSegmentReadyPromise() {
    var _this8 = this;

    var timeoutPromise = new Promise(function (resolve) {
      setTimeout(resolve, 3000);
    });
    var segmentReadyPromise = new Promise(function (resolve) {
      var _a;

      if ((_a = _this8.window) === null || _a === void 0 ? void 0 : _a.analytics) {
        _this8.window.analytics.ready(function () {
          resolve();
        });
      }
    });
    this.segmentReadyPromise = Promise.race([segmentReadyPromise, timeoutPromise]);
  };

  _proto7.sendSignedUpEventIfNecessary = function sendSignedUpEventIfNecessary(analyticsProperties) {
    if (!analyticsProperties) {
      return;
    } // Profile survey doesn't include `https://api.landr.com/` in keys


    var keyPrefix = 'is_signup' in analyticsProperties ? '' : 'https://api.landr.com/';

    if (analyticsProperties[keyPrefix + "is_signup"]) {
      this.window.analytics.track('Signed Up - Front End', {
        application_name: AnalyticsApplication.Account,
        signup_referrer_application: analyticsProperties[keyPrefix + "signup_referrer_application"],
        signup_method: analyticsProperties[keyPrefix + "signup_method"],
        landr_email: analyticsProperties[keyPrefix + "signup_landr_email"],
        first_name: analyticsProperties[keyPrefix + "signup_first_name"],
        last_name: analyticsProperties[keyPrefix + "signup_last_name"],
        signup_referrer: analyticsProperties[keyPrefix + "signup_referrer"],
        utm_term: analyticsProperties[keyPrefix + "signup_utm_term"],
        utm_source: analyticsProperties[keyPrefix + "signup_utm_source"],
        utm_medium: analyticsProperties[keyPrefix + "signup_utm_medium"],
        utm_content: analyticsProperties[keyPrefix + "signup_utm_content"],
        utm_campaign: analyticsProperties[keyPrefix + "signup_utm_campaign"]
      });
    }
  };

  _proto7.sendLoggedInEventIfNecessary = function sendLoggedInEventIfNecessary(analyticsProperties) {
    if (!analyticsProperties) {
      return;
    }

    var keyPrefix = 'https://api.landr.com/';

    if (analyticsProperties[keyPrefix + "is_login"]) {
      this.window.analytics.track('Logged In - Front End', {
        application_name: AnalyticsApplication.Account,
        login_method: analyticsProperties[keyPrefix + "login_login_method"],
        is_impersonate: analyticsProperties[keyPrefix + "login_is_impersonate"],
        utm_term: analyticsProperties[keyPrefix + "login_utm_term"],
        utm_source: analyticsProperties[keyPrefix + "login_utm_source"],
        utm_medium: analyticsProperties[keyPrefix + "login_utm_medium"],
        utm_content: analyticsProperties[keyPrefix + "login_utm_content"],
        utm_campaign: analyticsProperties[keyPrefix + "login_utm_campaign"]
      });
    }
  };

  return AbstractSegmentServiceV2;
}();

var supportedUTMParams = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];
var allSupportedParams = [].concat(supportedUTMParams);
var UTMsParamMapping = {
  utm_source: 'landr_utmSource',
  utm_campaign: 'landr_utmCampaign',
  utm_medium: 'landr_utmMedium',
  utm_content: 'landr_utmContent',
  utm_term: 'landr_utmTerm'
};

var saveUTMsToCookies = function saveUTMsToCookies(UTMCookieSettings) {
  var queryParams = new URLSearchParams(window.location.search);
  var isSupportedUTMParamsInURL = false; // Detect if any UTMs exist in the URL

  queryParams.forEach(function (value, param) {
    if (supportedUTMParams.includes(param)) {
      isSupportedUTMParamsInURL = true;
    }
  }); // Remove all UTM related Cookies if URL contains UTM params
  // BUT DO NOT remove partner params

  if (isSupportedUTMParamsInURL) {
    supportedUTMParams.forEach(function (param) {
      Cookies.remove(param, UTMCookieSettings);
    });
  } // Set UTM params in cookies


  queryParams.forEach(function (value, param) {
    if (allSupportedParams.includes(param)) {
      Cookies.set(param, value, UTMCookieSettings);
    }
  });
};

var getUTMsParams = function getUTMsParams(UTMCookieSettings) {
  var UTMs = {}; // First save UTMs to cookies, this will make sure we capture new UTMs from URL

  saveUTMsToCookies(UTMCookieSettings); // Then get them

  allSupportedParams.forEach(function (param) {
    if (Cookies.get(param)) {
      UTMs[UTMsParamMapping[param]] = Cookies.get(param);
    }
  }); // Add document referrer

  if (document.referrer) {
    UTMs.landr_utmDocumentReferrer = document.referrer;
  }

  return UTMs;
};

var supportedOfflineConversionParams = ['gclid', 'wbraid'];

var saveOfflineConversionToCookies = function saveOfflineConversionToCookies(cookieSettings) {
  var queryParams = new URLSearchParams(window.location.search);
  var isSupportedOfflineConversionParamsInURL = false; // Detect if any offline conversion param exist in the URL

  queryParams.forEach(function (value, param) {
    if (supportedOfflineConversionParams.includes(param)) {
      isSupportedOfflineConversionParamsInURL = true;
    }
  }); // Remove all offline conversion related Cookies if URL contains offline conversion params

  if (isSupportedOfflineConversionParamsInURL) {
    supportedOfflineConversionParams.forEach(function (param) {
      Cookies.remove(param, cookieSettings);
    });
  } // Set offline conversion params in cookies


  queryParams.forEach(function (value, param) {
    if (supportedOfflineConversionParams.includes(param)) {
      Cookies.set(param, value, cookieSettings);
    }
  });
};

var getOfflineConversion = function getOfflineConversion() {
  var hasOfflineConversion = false;
  var offlineConversion = {}; // Then get them

  supportedOfflineConversionParams.forEach(function (param) {
    if (Cookies.get(param)) {
      hasOfflineConversion = true;
      offlineConversion[param] = Cookies.get(param);
    }
  });
  return hasOfflineConversion ? offlineConversion : undefined;
};

var getWindowWidth = function getWindowWidth(localWindow) {
  return localWindow.document.documentElement ? localWindow.document.documentElement.clientWidth : localWindow.document.body.clientWidth;
};

var getGoogleAnalyticsClientId = function getGoogleAnalyticsClientId() {
  var clientId = null;

  if (window['ga']) {
    window['ga'](function (tracker) {
      return clientId = tracker.get('clientId');
    });
  }

  return clientId;
};

var getAnonymousId = function getAnonymousId() {
  return typeof window !== 'undefined' && window && window['analytics'] && window['analytics'].user && window['analytics'].user() && window['analytics'].user().anonymousId();
};
/**
 * Return the URL for the page and strip the hash.
 */


function pageUrl(localWindow) {
  var url = localWindow.location.href;
  var i = url.indexOf('#');
  return i === -1 ? url : url.slice(0, i);
}
/**
 * Return the title for the page and strip characters outside (US-ASCII charset)
 * In practice, most HTTP header field values use only a subset of the US-ASCII charset [USASCII].
 * See https://datatracker.ietf.org/doc/html/rfc7230#section-3.2.4 for more information
 */


function pageTitle(localWindow) {
  // ASCII is in range of 0 to 127 in unicode (0x7F is 127 in hex)
  // eslint-disable-next-line no-control-regex
  return localWindow.document.title.replace(/[^\x00-\x7F]/g, '');
}
/**
 * @deprecated Use `getXLandrAnalyticsV2` instead that has a simpler API
 * and does not returned deprecated properties.
 */


var getXLandrAnalytics = function getXLandrAnalytics(application, localWindow, platformNameOverride) {
  if (localWindow === void 0) {
    localWindow = window;
  }

  if (platformNameOverride === void 0) {
    platformNameOverride = undefined;
  }

  var providerContexts = [{
    name: 'Segment',
    clientId: getAnonymousId()
  }, {
    name: 'GoogleAnalytics',
    clientId: getGoogleAnalyticsClientId()
  }].filter(function (p) {
    return p.clientId;
  });
  var pageInfo = {
    name: getSanitizedPageName(localWindow.location.pathname),
    path: localWindow.location.pathname,
    referrer: localWindow.document.referrer,
    search: localWindow.location.search,
    title: pageTitle(localWindow),
    url: pageUrl(localWindow),
    platform: platformNameOverride !== null && platformNameOverride !== void 0 ? platformNameOverride : getPlatformName(localWindow),
    application: application
  };
  var offlineConversion = getOfflineConversion(); // region deprecated

  var page = localWindow.location.pathname;
  var deviceResolution = {
    height: localWindow.screen.height,
    width: localWindow.screen.width,
    devicePixelRatio: localWindow.devicePixelRatio
  };
  var windowResolution = {
    height: localWindow.innerHeight,
    width: getWindowWidth(localWindow),
    devicePixelRatio: localWindow.devicePixelRatio
  };
  var screenColors = localWindow.screen.colorDepth; // endregion

  return {
    providerContexts: providerContexts,
    pageInfo: pageInfo,
    // deprecated
    deviceResolution: deviceResolution,
    windowResolution: windowResolution,
    screenColors: screenColors,
    page: page,
    offlineConversion: offlineConversion
  };
};

var getXLandrAnalyticsV2 = function getXLandrAnalyticsV2(application, options) {
  var _a, _b, _c, _d;

  var providerContexts = [{
    name: 'Segment',
    clientId: (_a = options === null || options === void 0 ? void 0 : options.overrideAnonymousId) !== null && _a !== void 0 ? _a : getAnonymousId()
  }, {
    name: 'GoogleAnalytics',
    clientId: (_b = options === null || options === void 0 ? void 0 : options.overrideGoogleAnalyticsClientId) !== null && _b !== void 0 ? _b : getGoogleAnalyticsClientId()
  }].filter(function (p) {
    return p.clientId;
  });
  var localWindow = (_c = options === null || options === void 0 ? void 0 : options.overrideWindow) !== null && _c !== void 0 ? _c : window;
  var pageInfo = {
    name: getSanitizedPageName(localWindow.location.pathname),
    path: localWindow.location.pathname,
    referrer: localWindow.document.referrer,
    search: localWindow.location.search,
    title: pageTitle(localWindow),
    url: pageUrl(localWindow),
    platform: (_d = options === null || options === void 0 ? void 0 : options.overridePlatformName) !== null && _d !== void 0 ? _d : getPlatformName(localWindow),
    application: application
  };
  var offlineConversion = !(options === null || options === void 0 ? void 0 : options.disableOfflineConversion) ? getOfflineConversion() : undefined;
  return {
    offlineConversion: offlineConversion,
    pageInfo: pageInfo,
    providerContexts: providerContexts
  };
};
/**
 * Log service to be used in the browser
 */


var BrowserLogger =
/*#__PURE__*/
function (_LogService) {
  _inheritsLoose(BrowserLogger, _LogService);

  function BrowserLogger(options) {
    var _this9;

    _this9 = _LogService.call(this,
    /* eslint-disable no-console */
    {
      log: console.log,
      debug: console.log,
      info: console.log,
      warn: console.warn,
      error: console.error
    },
    /* eslint-enable no-console */
    {
      enabled: options.enabled,
      console: {
        enabled: options.console.enabled,
        minLevel: options.console.minLevel
      },
      separator: options.separator,
      module: options.module
    }) || this;
    _this9.options = options;
    _this9.options = options;
    _this9.loggly = _this9.createLogglyService();
    _this9.callback = _this9.logCallback.bind(_assertThisInitialized(_this9));
    return _this9;
  }

  var _proto8 = BrowserLogger.prototype;

  _proto8.logCallback = function logCallback(event) {
    var _a, _b;

    var extraParams = Object.assign({
      url: (_b = typeof window !== 'undefined' && ((_a = window.top) === null || _a === void 0 ? void 0 : _a.location.href)) !== null && _b !== void 0 ? _b : ''
    }, this.formatUserProfileToEventParams());
    this.loggly.send(event, extraParams);
  };

  _proto8.formatUserProfileToEventParams = function formatUserProfileToEventParams() {
    if (this._userProfile) {
      return {
        userId: this._userProfile.userId,
        anonymousId: ''
      };
    } else {
      return {
        userId: '',
        anonymousId: getAnonymousId()
      };
    }
  };

  _proto8.createLogglyService = function createLogglyService() {
    var _a;

    var config = {
      apiKey: this.options.loggly.apiKey,
      enabled: this.options.loggly.enabled,
      minLevel: this.options.loggly.minLevel,
      tags: this.options.loggly.tags,
      maxBundleSize: this.options.loggly.maxBundleSize,
      forcedModule: (_a = this.options.loggly.forcedModule) !== null && _a !== void 0 ? _a : {}
    };
    var properties = {
      serviceKey: this.options.serviceKey,
      deploymentKind: this.options.deploymentKind,
      version: this.options.version,
      application: this.options.application,
      consecutiveOccurrences: this.options.loggly.consecutiveOccurrences
    };
    return new LogglyService(config, properties, typeof window !== 'undefined' ? window : undefined);
  };

  _createClass(BrowserLogger, [{
    key: "userProfile",
    set: function set(userProfile) {
      this._userProfile = userProfile;
    }
  }]);

  return BrowserLogger;
}(LogService);

var ScriptLoader =
/*#__PURE__*/
function () {
  function ScriptLoader() {
    window.__landrCoreLoadedScripts = window.__landrCoreLoadedScripts || {};
    this.loadedScripts = window.__landrCoreLoadedScripts;
  }
  /**
   * Returns a promise that is resolved only when all the scripts are fully loaded
   * @param {string[]} scriptUrls Array of URLs to load
   * @returns {Promise}
   */


  var _proto9 = ScriptLoader.prototype;

  _proto9.loadScripts = function loadScripts(scriptUrls) {
    var _this10 = this;

    scriptUrls = scriptUrls || [];
    return Promise.all(scriptUrls.map(function (scriptUrl) {
      return _this10.loadScript(scriptUrl);
    }));
  }
  /**
   * Returns a promise that is resolved when the script is fully loaded
   * @param {string} scriptUrl URL of the script to load
   * @returns {Promise}
   */
  ;

  _proto9.loadScript = function loadScript(scriptUrl) {
    var loadedScript = this.loadedScripts[scriptUrl];

    if (!loadedScript) {
      loadedScript = new Promise(function (resolve, reject) {
        var _a;

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = scriptUrl;
        script.addEventListener('load', resolve, false);
        script.addEventListener('error', reject, false);
        script.addEventListener('abort', reject, false);
        var firstScriptOnPage = window.document.getElementsByTagName('script')[0];
        (_a = firstScriptOnPage === null || firstScriptOnPage === void 0 ? void 0 : firstScriptOnPage.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, firstScriptOnPage);
      });
      this.loadedScripts[scriptUrl] = loadedScript;
    }

    return loadedScript;
  };

  return ScriptLoader;
}();

var eventAppPrefix = 'landr-app-';
var eventContentPrefix = 'landr-devtools-content-';
var listeners = {};
var sessionStorageForcedFlagKey = 'landrForcedFlags';
var sessionStorageForcedAppConfigKey = 'landrForcedAppConfig';

var areDevToolsActive = function areDevToolsActive() {
  var appBody = document.getElementsByTagName('body')[0];
  var isDevtoolsActive = appBody.getAttribute('data-landr-devtools');
  return !!isDevtoolsActive;
};

var sendToDevTools = function sendToDevTools(type, payload) {
  var message = Object.assign({
    action: "" + eventAppPrefix + type
  }, payload);
  window.postMessage(message, '*');
};

var listenToWindowMessage = function listenToWindowMessage() {
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('message', function (event) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var type;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (event.source === window && event.data && event.data.action && event.data.action.startsWith(eventContentPrefix)) {
                  type = event.data.action.substr(eventContentPrefix.length);

                  if (listeners[type]) {
                    listeners[type].forEach(function (callback) {
                      try {
                        callback({
                          payload: event.data
                        });
                      } catch (e) {
                        console.error('[core] cannot call event listener', e);
                      }
                    });
                  }
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    });
  }
};

listenToWindowMessage();
/**
 * subscribes to specific event from devtools
 * @return destroy method to unsubscribe
 */

var subscribeFromDevTools = function subscribeFromDevTools(type, callback) {
  if (!(type in listeners)) {
    listeners[type] = [];
  }

  listeners[type].push(callback); // Destroy method

  return function () {
    if (listeners[type]) {
      var pos = listeners[type].indexOf(callback);

      if (pos >= 0) {
        listeners[type].splice(pos, 1);
      }
    }
  };
};

var getCachedForcedFlags = function getCachedForcedFlags(applicationName) {
  var _a;

  var cachedValue = sessionStorage.getItem(sessionStorageForcedFlagKey);
  var parsedCacheValue = cachedValue ? JSON.parse(cachedValue) : {};
  return (_a = parsedCacheValue[applicationName]) !== null && _a !== void 0 ? _a : {};
};

var getCachedAppConfig = function getCachedAppConfig(applicationName) {
  var _a;

  var cachedValue = sessionStorage.getItem(sessionStorageForcedAppConfigKey);
  var parsedCacheValue = cachedValue ? JSON.parse(cachedValue) : {};
  return (_a = parsedCacheValue[applicationName]) !== null && _a !== void 0 ? _a : {};
};
/**
 * Send an event to LANDR devtools with the initial application details
 */


var setupLandrDevTools = function setupLandrDevTools(applicationName, applicationVersion, config) {
  var message = {
    action: eventAppPrefix + "setup",
    name: applicationName,
    version: applicationVersion,
    config: config,
    isLocal: process.env.NODE_ENV !== 'production'
  };

  if (areDevToolsActive()) {
    window.postMessage(message, '*');
  } else {
    var callback = function callback(mutationList, observer) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(mutationList), _step2; !(_step2 = _iterator2()).done;) {
        var mutation = _step2.value;

        if (mutation.type === 'attributes' && mutation.attributeName === 'data-landr-devtools') {
          window.postMessage(message, '*');
          observer.disconnect();
        }
      }
    };

    var observer = new MutationObserver(callback);
    var appBody = document.getElementsByTagName('body')[0];
    observer.observe(appBody, {
      attributes: true,
      childList: false,
      subtree: false
    });
  }
};

var eventListenerKey = function eventListenerKey(eventType) {
  return "LandrEvent." + eventType;
};

function addLandrEventListener(eventType, callback) {
  var eventKey = eventListenerKey(eventType);

  var onMessage = function onMessage(event) {
    if (event.data.type === eventKey) {
      callback(event.data.payload);
    }
  };

  window.addEventListener('message', onMessage);
  return function () {
    window.removeEventListener('message', onMessage);
  };
}

function broadcastLandrEvent(eventType, payload) {
  var eventKey = eventListenerKey(eventType);
  window.postMessage({
    type: eventKey,
    payload: payload
  }, '*');
}

var LandrEventType;

(function (LandrEventType) {
  LandrEventType["DeviceAuthorizationWaitingStart"] = "DeviceAuthorizationWaitingStart";
  LandrEventType["DeviceAuthorizationStart"] = "DeviceAuthorizationStart";
  LandrEventType["DeviceAuthorizationStarted"] = "DeviceAuthorizationStarted";
  LandrEventType["DeviceAuthorizationCancel"] = "DeviceAuthorizationCancel";
  LandrEventType["DeviceAuthorizationEnded"] = "DeviceAuthorizationEnded";
  LandrEventType["UserAvatarUpdate"] = "UserAvatarUpdate";
  LandrEventType["UserProfileCompletionUpdate"] = "UserProfileCompletionUpdate";
  LandrEventType["UserProfileWorkAvailabilityUpdate"] = "UserProfileWorkAvailabilityUpdate";
  LandrEventType["UserProfilePrivacyUpdate"] = "UserProfilePrivacyUpdate";
  LandrEventType["LockAutoRefresh"] = "LockAutoRefresh";
  LandrEventType["UnlockAutoRefresh"] = "UnlockAutoRefresh";
  LandrEventType["ReleaseWizardQuit"] = "ReleaseWizardQuit";
  LandrEventType["ReleaseWizardGoToStep"] = "ReleaseWizardGoToStep";
  LandrEventType["ReleaseWizardValidate"] = "ReleaseWizardValidate";
  LandrEventType["ReleaseWizardStepError"] = "ReleaseWizardStepError";
  LandrEventType["ReleaseWizardStepSuccess"] = "ReleaseWizardStepSuccess";
  LandrEventType["ReleaseWizardSubmit"] = "ReleaseWizardSubmit";
  LandrEventType["ReleaseWizardSaveAndQuit"] = "ReleaseWizardSaveAndQuit";
  LandrEventType["ReleaseWizardTriggerForceSave"] = "ReleaseWizardTriggerForceSave";
  LandrEventType["ReleaseWizardStartSave"] = "ReleaseWizardStartSave";
  LandrEventType["ReleaseWizardSaveEnd"] = "ReleaseWizardSaveEnd";
  LandrEventType["ReleaseWizardLegacyStateChange"] = "ReleaseWizardLegacyStateChange";
  LandrEventType["ReleaseWizardStartTrackUpload"] = "ReleaseWizardStartTrackUpload";
  LandrEventType["ReleaseWizardEndTrackUpload"] = "ReleaseWizardEndTrackUpload";
  LandrEventType["ReleaseWizardArtistsInUseUpdate"] = "ReleaseWizardArtistsInUseUpdate";
  LandrEventType["ReleaseWizardDisableNextAction"] = "ReleaseWizardDisableNextAction";
  LandrEventType["ReleaseWizardEnableNextAction"] = "ReleaseWizardEnableNextAction";
  LandrEventType["SessionsReservationRoomsChange"] = "SessionsReservationRoomsChange";
  LandrEventType["ReleaseWizardSubmitPermissionsChange"] = "ReleaseWizardSubmitPermissionsChange";
})(LandrEventType || (LandrEventType = {}));

var LandrSupportOrigin = 'https://support.landr.com';
var SupportRequestPathname = '/requests/new';

var getEnvSuffix = function getEnvSuffix(environment) {
  switch (environment) {
    case 'development':
      return '-dev';

    case 'demo':
      return '-demo';

    case 'partner':
      return '-partner';

    case 'production':
    default:
      return '';
  }
};

var networkMainAppPrefix = 'network';

var getEnvDomain = function getEnvDomain(environment) {
  return getEnvSuffix(environment) + ".landr.com";
};

var getDevOrProdEnvSuffix = function getDevOrProdEnvSuffix(environment) {
  switch (environment) {
    case 'development':
    case 'demo':
    case 'partner':
      return '-dev';

    case 'production':
    default:
      return '';
  }
};

var getWebAppLink = function getWebAppLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '/';
  }

  var currentHost = typeof window !== 'undefined' ? window.location.host : '';
  var isOnLocalWebapp = currentHost && currentHost.match(/^local\.landr\.com:9102$/);
  var envSuffix = getEnvSuffix(env);
  var isOnVendorApp = currentHost && (currentHost.match(new RegExp("^app-[\\w-]+" + envSuffix + "\\.landr\\.com$")) || currentHost.match(new RegExp("^[\\w-]+" + envSuffix + "\\.music\\.tech$")) || currentHost.match(new RegExp("^app" + envSuffix + "\\.soundonsound\\.io$")));

  if (isOnLocalWebapp || isOnVendorApp) {
    return "https://" + currentHost + pathname;
  } else {
    return "https://app" + envSuffix + ".landr.com" + pathname;
  }
};

var getSameOriginLink = function getSameOriginLink(pathname) {
  return "" + window.location.origin + pathname;
};

var getSupportLink = function getSupportLink(_ref4) {
  var language = _ref4.language,
      _ref4$pathname = _ref4.pathname,
      pathname = _ref4$pathname === void 0 ? '/' : _ref4$pathname,
      origin = _ref4.origin;

  if (origin !== LandrSupportOrigin) {
    if (pathname.includes(SupportRequestPathname)) {
      return origin + "/hc/" + (language === Languages.English ? 'en-us' : language) + SupportRequestPathname;
    }

    return origin + "/hc/" + (language === Languages.English ? 'en-us' : language);
  }

  return origin + "/hc/" + (language === Languages.English ? 'en-us' : language) + pathname;
};

var getGuestSiteLink = function getGuestSiteLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '/';
  }

  var domain;

  switch (env) {
    case 'development':
      domain = 'dev.landr.com';
      break;

    case 'demo':
      domain = 'demo.landr.com';
      break;

    case 'partner':
      domain = 'partner.landr.com';
      break;

    case 'production':
    default:
      domain = 'www.landr.com';
      break;
  }

  return "https://" + domain + pathname;
};

var getSamplesLink = function getSamplesLink(env, pathname, options) {
  if (pathname === void 0) {
    pathname = '/';
  }

  if (options === void 0) {
    options = {
      isSamplesInWebApp: false
    };
  }

  if (options.isSamplesInWebApp) {
    return getWebAppLink(env, "/samples" + pathname);
  }

  return "https://samples" + getEnvDomain(env) + pathname;
};

var getChromaticLink = function getChromaticLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '/';
  }

  return "https://chromatic" + getEnvDomain(env) + pathname;
};

var getSessionsLink = function getSessionsLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '';
  }

  return "" + getWebAppLink(env, "/sessions" + pathname);
};

var getSessionsRoomLink = function getSessionsRoomLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '/';
  }

  return "https://sessions" + getEnvDomain(env) + pathname;
};

var getNetworkLink = function getNetworkLink(env, pathname, options) {
  if (pathname === void 0) {
    pathname = '';
  }

  if (options === void 0) {
    options = {
      isNetworkAngularMfeInWebApp: false
    };
  }

  if (options.isNetworkAngularMfeInWebApp) {
    return getWebAppLink(env, "/" + networkMainAppPrefix + pathname);
  }

  var networkLink = "https://network" + getEnvDomain(env) + pathname;
  return networkLink;
};

var getEducationLink = function getEducationLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '/';
  }

  return "https://learn" + getDevOrProdEnvSuffix(env) + ".landr.com" + pathname;
};

var getRootApiUri = function getRootApiUri(env, pathname) {
  return "https://api3" + getEnvSuffix(env) + ".landr.com" + (pathname !== null && pathname !== void 0 ? pathname : '');
};

var getMsApiUri = function getMsApiUri(env, msName) {
  return getRootApiUri(env, "/" + msName + "/api");
};

var LOCAL_GRAPHQL_HTTP_URI = 'http://localhost:4002';
var LOCAL_GRAPHQL_WS_URI = 'ws://localhost:4002';

var getGraphqlHttpUri = function getGraphqlHttpUri(env, params) {
  var _a; // Core-BFF must have `/` at the end to be reachable


  return (params === null || params === void 0 ? void 0 : params.isLocal) ? LOCAL_GRAPHQL_HTTP_URI : getRootApiUri(env, "/core-bff-v2" + ((_a = params === null || params === void 0 ? void 0 : params.pathname) !== null && _a !== void 0 ? _a : '/'));
};

var getGraphqlWsUri = function getGraphqlWsUri(env, isLocal) {
  if (isLocal) {
    return LOCAL_GRAPHQL_WS_URI;
  }

  if (env === 'production') {
    return "wss://ws.landr.com/core-bff-v2/";
  }

  return "wss://api3" + getEnvSuffix(env) + "-ws.landr.com/core-bff-v2/";
};

var getAssetsUri = function getAssetsUri(env, pathname) {
  return "https://assets" + getEnvSuffix(env) + ".landr.com" + (pathname !== null && pathname !== void 0 ? pathname : '');
};

var getBlogLink = function getBlogLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '';
  }

  return "https://blog" + getEnvDomain(env) + pathname;
};

var getRedeemAProductLink = function getRedeemAProductLink(env, pathname) {
  if (pathname === void 0) {
    pathname = '';
  }

  return "https://redeem" + getEnvDomain(env) + pathname;
};

var getStudioAILink = function getStudioAILink(env, pathname) {
  if (pathname === void 0) {
    pathname = '';
  }

  return "https://app" + getEnvSuffix(env) + ".landr.com/studio-ai" + pathname;
};

var TermsOfServicePathnames = (_TermsOfServicePathna = {}, _TermsOfServicePathna[Languages.English] = '/terms-of-service', _TermsOfServicePathna[Languages.French] = '/fr/conditions-de-service', _TermsOfServicePathna[Languages.German] = '/de/nutzungsbedingungen', _TermsOfServicePathna[Languages.Italian] = '/it/termini-di-servizio', _TermsOfServicePathna[Languages.Japanese] = '/ja/%E3%82%B5%E3%83%BC%E3%83%92%E3%82%B9%E8%A6%8F%E7%B4%84', _TermsOfServicePathna[Languages.Portuguese] = '/pt/termos-de-servico', _TermsOfServicePathna[Languages.Spanish] = '/es/condiciones-de-servicio', _TermsOfServicePathna);
var PrivacyPolicyPathnames = (_PrivacyPolicyPathnam = {}, _PrivacyPolicyPathnam[Languages.English] = '/privacy', _PrivacyPolicyPathnam[Languages.French] = '/fr/politique-de-confidentialite', _PrivacyPolicyPathnam[Languages.German] = '/de/datenschutzerklarung', _PrivacyPolicyPathnam[Languages.Italian] = '/it/politica-sulla-privacy', _PrivacyPolicyPathnam[Languages.Japanese] = '/ja/%E3%83%95%E3%83%A9%E3%82%A4%E3%83%8F%E3%82%B7%E3%83%BC%E8%A6%8F%E7%B4%84', _PrivacyPolicyPathnam[Languages.Portuguese] = '/pt/politica-de-privacidade', _PrivacyPolicyPathnam[Languages.Spanish] = '/es/poliza-de-privacidad', _PrivacyPolicyPathnam);

var getPrivacyPolicyRootLink = function getPrivacyPolicyRootLink(_ref5) {
  var originUrl = _ref5.originUrl,
      locale = _ref5.locale;

  if (originUrl === 'https://www.landr.com') {
    return "" + originUrl + PrivacyPolicyPathnames[locale];
  }

  return originUrl + "/terms#privacy-policy";
};

var getTermsOfServiceRootLink = function getTermsOfServiceRootLink(_ref6) {
  var originUrl = _ref6.originUrl,
      locale = _ref6.locale;

  if (originUrl === 'https://www.landr.com') {
    return "" + originUrl + TermsOfServicePathnames[locale];
  }

  return originUrl + "/terms";
};

function isDesktopApp() {
  return Boolean(window === null || window === void 0 ? void 0 : window.electronPreload);
}

var networkUrlRegex = /^network(-(dev|demo|partner))?\.landr\.com/;
var blogUrlRegex = /blog-?[a-z]*\.landr\.com/;
var pluginsMarketPlaceUrlRegex = /^plugins(-(dev|demo|partner))?\.landr\.com/;
var samplesUrlRegex = /^samples(-(dev|demo|partner))?\.landr\.com/;
var webAppUrlRegex = /^app(-(dev|demo|partner))?\.landr\.com/;
var isBrowser = typeof window !== 'undefined';

var openLink = function openLink(link, forceNewWindow) {
  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  var url = new URL(link);
  var currentHost = isBrowser ? window.location.host : '';
  var isCurrentHostAndPort = currentHost === url.host; // When already Samples, using window.history.pushState doesn't register the page changes.

  var isUnsupportedLandrHost = currentHost.includes('samples');

  if (forceNewWindow) {
    window.open(link, '_blank');
  } else if (isCurrentHostAndPort && !isUnsupportedLandrHost) {
    window.history.pushState({}, '', link);
  } else {
    window.open(link, getWindowTarget(url));
  }
};

function getWindowTarget(url) {
  var currentHost = isBrowser ? window === null || window === void 0 ? void 0 : window.location.host : ''; // Open network, plugins marketplace and samples in current tab even on desktop app

  if (networkUrlRegex.test(url.host) || pluginsMarketPlaceUrlRegex.test(url.host) || samplesUrlRegex.test(url.host)) {
    return '_self';
  } // When navigating back from another app than web app


  if ((networkUrlRegex.test(currentHost) || blogUrlRegex.test(currentHost) || samplesUrlRegex.test(currentHost) || pluginsMarketPlaceUrlRegex.test(currentHost)) && webAppUrlRegex.test(url.host)) {
    return '_self';
  } // Open blog in new tab


  if (blogUrlRegex.test(url.host)) {
    return '_blank';
  }

  return isDesktopApp() || !url.host.includes('landr.com') ? '_blank' : '_self';
}

var openWebAppLink = function openWebAppLink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '/';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  openLink(getWebAppLink(env, pathname), forceNewWindow);
};

var openSupportLink = function openSupportLink(_ref7) {
  var language = _ref7.language,
      _ref7$pathname = _ref7.pathname,
      pathname = _ref7$pathname === void 0 ? '/' : _ref7$pathname,
      origin = _ref7.origin,
      _ref7$forceNewWindow = _ref7.forceNewWindow,
      forceNewWindow = _ref7$forceNewWindow === void 0 ? true : _ref7$forceNewWindow;
  openLink(getSupportLink({
    language: language,
    pathname: pathname,
    origin: origin
  }), forceNewWindow);
};

var openGuestSiteLink = function openGuestSiteLink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '/';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  openLink(getGuestSiteLink(env, pathname), forceNewWindow);
};

var openSamplesLink = function openSamplesLink(env, pathname, options) {
  if (pathname === void 0) {
    pathname = '/';
  }

  if (options === void 0) {
    options = {
      isSamplesInWebApp: false,
      forceNewWindow: false
    };
  }

  return openLink(getSamplesLink(env, pathname, options), options.forceNewWindow);
};

var openSessionsLink = function openSessionsLink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  return openLink(getSessionsLink(env, pathname), forceNewWindow);
};

var openNetworkLink = function openNetworkLink(env, pathname, options) {
  if (pathname === void 0) {
    pathname = '';
  }

  if (options === void 0) {
    options = {
      isNetworkAngularMfeInWebApp: false,
      forceNewWindow: false
    };
  }

  return openLink(getNetworkLink(env, pathname, options), options.forceNewWindow);
};

var openWebAppHomeLink = function openWebAppHomeLink(env, forceNewWindow) {
  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  openWebAppLink(env, '/dashboard', forceNewWindow);
};

var openEducationLink = function openEducationLink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '/';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  return openLink(getEducationLink(env, pathname), forceNewWindow);
};

var openRedeemAProductLink = function openRedeemAProductLink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  return openLink(getRedeemAProductLink(env, pathname), forceNewWindow);
};

var openStudioAILink = function openStudioAILink(env, pathname, forceNewWindow) {
  if (pathname === void 0) {
    pathname = '';
  }

  if (forceNewWindow === void 0) {
    forceNewWindow = false;
  }

  var link = getStudioAILink(env, pathname); // We are not using `openLink` here because the Studio app is not using client side navigation
  // We need to do a full refresh of the page to get the new page

  window.open(link, forceNewWindow ? '_blank' : '_self');
};

var MaxRetryAttempts = 5;
var RetryBaseDelayMs = 300; // 300ms (like the BFF RetryLink)

var fetchWithRetries = function fetchWithRetries(input, init, retryCount) {
  var fetchWithRetry = fetchRetry(fetch);
  return fetchWithRetry(input, Object.assign({
    retries: retryCount !== null && retryCount !== void 0 ? retryCount : MaxRetryAttempts,
    // The default behavior of fetch-retry is to wait a fixed amount of time between attempts.
    // We use exponential backoff
    retryDelay: function retryDelay(attempt) {
      return Math.pow(2, attempt) * RetryBaseDelayMs; // 0, 300, 600, 1200, 2400, 4800 (ms) = 9300 ms = 9.3s total
    },
    // The default behavior of fetch-retry is to only retry requests on network related issues,
    // but we also added the retry on specific HTTP status codes, so it will catch both cases.
    retryOn: [503]
  }, init));
};

var extractUserIdFromAuthorizationHeader = function extractUserIdFromAuthorizationHeader(headers) {
  var _a;

  try {
    var authorizationHeader = (_a = headers['Authorization']) !== null && _a !== void 0 ? _a : headers['authorization'];

    if (!authorizationHeader) {
      return undefined;
    }

    var authorizationHeaderParts = authorizationHeader.split(' ');

    if (authorizationHeaderParts.length !== 2) {
      return undefined;
    }

    var authorizationType = authorizationHeaderParts[0];

    if (authorizationType !== 'Bearer') {
      return undefined;
    }

    var authorizationToken = authorizationHeaderParts[1];

    if (!authorizationToken) {
      return undefined;
    }

    var jwtDecoded = jwt_decode(authorizationToken);

    if (typeof jwtDecoded === 'object') {
      return jwtDecoded['https://api.landr.com/nameid'];
    }

    return undefined;
  } catch (e) {
    // Failed silently, we need to be fail safe
    return undefined;
  }
};

var ApiLanguages = (_ApiLanguages = {}, _ApiLanguages[Languages.English] = 'en-US', _ApiLanguages[Languages.French] = 'fr-FR', _ApiLanguages[Languages.German] = 'de-DE', _ApiLanguages[Languages.Italian] = 'it-IT', _ApiLanguages[Languages.Japanese] = 'ja-JP', _ApiLanguages[Languages.Portuguese] = 'pt-BR', _ApiLanguages[Languages.Spanish] = 'es-ES', _ApiLanguages);

var fetchWithCommonHeaders = function fetchWithCommonHeaders(input, init, properties) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var _a, _b, _c, analyticContext, lang, correlationId, commonHeaders, url, retryCount, headers, userId, response;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            analyticContext = properties.analytics ? getXLandrAnalytics(properties.analytics.application, properties.analytics.window, properties.analytics.platformName) : undefined;
            lang = ApiLanguages[(_a = properties.language) !== null && _a !== void 0 ? _a : DefaultLanguage];
            correlationId = v4();
            commonHeaders = {
              'X-API-Languages': lang,
              'X-LANDR-ANALYTICS': JSON.stringify(analyticContext),
              'x-landr-featureflags': JSON.stringify((_b = properties.featureFlags) !== null && _b !== void 0 ? _b : {}),
              'X-CorrelationId': correlationId
            };
            url = typeof input === 'string' ? input : input.url;
            retryCount = (_c = properties.retryCount) !== null && _c !== void 0 ? _c : MaxRetryAttempts;
            headers = init && init.headers ? Object.assign(Object.assign({}, init.headers), commonHeaders) : commonHeaders;
            userId = extractUserIdFromAuthorizationHeader(headers);
            _context5.prev = 8;
            _context5.next = 11;
            return fetchWithRetries(input, Object.assign(Object.assign({}, init), {
              headers: headers
            }), retryCount);

          case 11:
            response = _context5.sent;

            if (!response.ok) {
              properties.log.warn("Fetch - Response status is not OK: " + response.status, CommonEventIds.FetchResponseIsNotOk, undefined, {
                correlationId: correlationId,
                userId: userId,
                url: url,
                retryCount: retryCount,
                status: response.status,
                statusText: response.statusText
              });
            }

            return _context5.abrupt("return", response);

          case 16:
            _context5.prev = 16;
            _context5.t0 = _context5["catch"](8);
            properties.log.warn("Fetch - Failed", CommonEventIds.FetchFailedError, _context5.t0, {
              correlationId: correlationId,
              userId: userId,
              url: url,
              retryCount: retryCount
            });
            throw _context5.t0;

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[8, 16]]);
  }));
};
/**
 * To prevent ResizeObserver errors, we limit it using a requestAnimationFrame.
 * See https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded/58701523#58701523
 * It will prevent errors like:
 * - "ResizeObserver loop limit exceeded"
 * - "ResizeObserver loop completed with undelivered notifications"
 */


var initCalmResizeObserver = function initCalmResizeObserver() {
  if (typeof window !== 'undefined' && typeof window.ResizeObserver !== 'undefined') {
    var CalmResizeObserver =
    /*#__PURE__*/
    function (_ResizeObserver) {
      _inheritsLoose(CalmResizeObserver, _ResizeObserver);

      function CalmResizeObserver(callback) {
        return _ResizeObserver.call(this, function (entries, observer) {
          requestAnimationFrame(function () {
            callback(entries, observer);
          });
        }) || this;
      }

      return CalmResizeObserver;
    }(
    /*#__PURE__*/
    _wrapNativeSuper(ResizeObserver));

    window.ResizeObserver = CalmResizeObserver;
  }
};

var extractFirstLetterAsUppercase = function extractFirstLetterAsUppercase(word) {
  return !word ? '' : word.charAt(0).toUpperCase();
};

var getInitialsFromFullName = function getInitialsFromFullName(fullName) {
  if (!fullName) {
    return '';
  }

  var nameSplit = fullName.replace(/[^a-z ]/gi, ' ').replace(/[\s]+/gi, ' ').split(' ') || [];

  if (!nameSplit) {
    return '';
  } else if (nameSplit.length === 1) {
    return extractFirstLetterAsUppercase(nameSplit[0]);
  }

  return "" + extractFirstLetterAsUppercase(nameSplit[0]) + extractFirstLetterAsUppercase(nameSplit[1]);
};

var getInitials = function getInitials(user) {
  return extractFirstLetterAsUppercase(user.firstname) + extractFirstLetterAsUppercase(user.lastname);
};
/*
 * This function is a utility function on top of Promise.allSettled that ensures:
 * - wait until all the promises provided have completed (success OR error)
 * - produce a rejection  if at least one of those promises is rejected
 * - aggregate errors if multiple promises are rejected
 *
 * Source: https://chezsoi.org/lucas/blog/a-tricky-pitfall-of-promiseall-and-a-solution.html
 * Context: https://github.com/LandrAudio/LANDR.MobileApp/pull/876
 *
 * @param promises - The promises to wait for.
 * @returns The results of the promises.
 */


function waitForPromises(promises) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var results, rejectedResults, successfullResults;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Promise.allSettled(promises);

          case 2:
            results = _context6.sent;
            rejectedResults = results.filter(function (result) {
              return result.status === 'rejected';
            });

            if (!(rejectedResults.length === 1)) {
              _context6.next = 6;
              break;
            }

            throw rejectedResults[0].reason;

          case 6:
            if (!(rejectedResults.length > 1)) {
              _context6.next = 8;
              break;
            }

            throw new AggregateError(rejectedResults.map(function (result) {
              return result.reason;
            }), rejectedResults.length + " promises failed");

          case 8:
            successfullResults = results.filter(function (result) {
              return result.status === 'fulfilled';
            });
            return _context6.abrupt("return", successfullResults.map(function (result) {
              return result.value;
            }));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

function mockBuilder(defaults) {
  return function (overrides) {
    return Object.assign(Object.assign({}, defaults), overrides);
  };
}

var convertLocale = function convertLocale(locale) {
  if (locale === void 0) {
    locale = 'en';
  }

  return Locales[locale] || Locales.en;
};

var slugifyText = function slugifyText(text) {
  return text.replace(/[\s&]+/g, '-').toLowerCase();
};

var convertToPascalCase = function convertToPascalCase(str) {
  var words = str.split(/[^a-zA-Z0-9]+/).filter(function (word) {
    return word.length > 0;
  });
  return words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join('');
};

var sanitizeForPath = function sanitizeForPath(path) {
  return path.replace(/[^a-zA-Z0-9-_]/g, '_');
};

var DesktopAppEvents;

(function (DesktopAppEvents) {
  DesktopAppEvents["SignOut"] = "sign-out";
  DesktopAppEvents["ToggleNotifications"] = "toggle-desktop-notifications";
})(DesktopAppEvents || (DesktopAppEvents = {}));
/**
 * Base Consent Error
 */


var AnalyticsConsentError =
/*#__PURE__*/
function (_Error) {
  _inheritsLoose(AnalyticsConsentError, _Error);
  /**
   *
   * @param name - Pass the name explicitly to work around the limitation that 'name' is automatically set to the parent class.
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/extends#using_extends
   * @param message - Error message
   */


  function AnalyticsConsentError(name, message) {
    var _this11;

    _this11 = _Error.call(this, message) || this;
    _this11.name = name;
    return _this11;
  }

  return AnalyticsConsentError;
}(
/*#__PURE__*/
_wrapNativeSuper(Error));

var ValidationError =
/*#__PURE__*/
function (_AnalyticsConsentErro) {
  _inheritsLoose(ValidationError, _AnalyticsConsentErro);

  function ValidationError(message, received) {
    if (arguments.length === 2) {
      // to ensure that explicitly passing undefined as second argument still works
      message += " (Received: " + JSON.stringify(received) + ")";
    }

    return _AnalyticsConsentErro.call(this, 'ValidationError', "[Validation] " + message) || this;
  }

  return ValidationError;
}(AnalyticsConsentError);

function assertIsFunction(val, variableName) {
  if (typeof val !== 'function') {
    throw new ValidationError(variableName + " is not a function", val);
  }
}

function assertIsObject(val, variableName) {
  if (val === null || typeof val !== 'object') {
    throw new ValidationError(variableName + " is not an object", val);
  }
}

function validateCategories(ctgs) {
  var hasError = true;

  if (ctgs && typeof ctgs === 'object' && !Array.isArray(ctgs)) {
    hasError = false;

    for (var k in ctgs) {
      if (typeof ctgs[k] !== 'boolean') {
        hasError = true;
        break;
      }
    }
  }

  if (hasError) {
    throw new ValidationError("Consent Categories should be {[categoryName: string]: boolean}", ctgs);
  }
}

function validateSettings(options) {
  if (typeof options !== 'object' || !options) {
    throw new ValidationError('Options should be an object', options);
  }

  assertIsFunction(options.getCategories, 'getCategories');
  options.shouldLoadSegment && assertIsFunction(options.shouldLoadSegment, 'shouldLoadSegment');
  options.shouldEnableIntegration && assertIsFunction(options.shouldEnableIntegration, 'shouldEnableIntegration');
  options.shouldDisableSegment && assertIsFunction(options.shouldDisableSegment, 'shouldDisableSegment');
  options.integrationCategoryMappings && assertIsObject(options.integrationCategoryMappings, 'integrationCategoryMappings');
  options.registerOnConsentChanged && assertIsFunction(options.registerOnConsentChanged, 'registerOnConsentChanged');
}

function validateAnalyticsInstance(analytics) {
  assertIsObject(analytics, 'analytics');

  if ('load' in analytics && 'addSourceMiddleware' in analytics && 'addDestinationMiddleware' in analytics && 'track' in analytics) {
    return;
  }

  throw new ValidationError('analytics is not an Analytics instance', analytics);
}
/**
 * Everyday variadic pipe function (reverse of 'compose')
 * @example pipe(fn1, fn2, fn3)(value) // fn3(fn2(fn1(value)))
 */


var pipe = function pipe(fn) {
  for (var _len2 = arguments.length, fns = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fns[_key2 - 1] = arguments[_key2];
  }

  var piped = fns.reduce(function (prevFn, nextFn) {
    return function (value) {
      return nextFn(prevFn(value));
    };
  }, function (value) {
    return value;
  });
  return function () {
    return piped(fn.apply(void 0, arguments));
  };
};
/**
 *
 * @param condition - predicate function that, if true, will cause the promise to resolve.
 * @param delayMs - The frequency, in milliseconds (thousandths of a second), to check the condition.
 * @example
 * ```ts
 * // check 'readyState' every 500ms
 * await resolveWhen(() => document.readyState === 'complete', 500)
 * ```
 */


function resolveWhen(_x, _x2) {
  return _resolveWhen.apply(this, arguments);
}
/**
 * This function removes duplicates from an array
 */


function _resolveWhen() {
  _resolveWhen = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee17(condition, delayMs) {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", new Promise(function (resolve, _reject) {
              if (condition()) {
                resolve();
                return;
              }

              var check = function check() {
                return setTimeout(function () {
                  if (condition()) {
                    resolve();
                  } else {
                    check();
                  }
                }, delayMs);
              };

              check();
            }));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _resolveWhen.apply(this, arguments);
}

var uniq = function uniq(arr) {
  return Array.from(new Set(arr));
};
/**
 * @example
 * pick({ a: 1, b: 2, c: 3 }, ['a', 'c']) => { a: 1, c: 3 }
 */


var pick = function pick(obj, keys) {
  return keys.reduce(function (acc, k) {
    if (k in obj) {
      acc[k] = obj[k];
    }

    return acc;
  }, {});
};
/**
 * Helper function for exhaustive checks of discriminated unions.
 */


function assertNever(value) {
  throw new Error("Unhandled discriminated union member: " + JSON.stringify(value));
} // hacky debug.ts, can be replaced with a proper logging solution
// @ts-ignore


var Logger =
/*#__PURE__*/
function () {
  function Logger() {}

  var _proto10 = Logger.prototype;

  _proto10.enableDebugLogging = function enableDebugLogging() {
    window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] = true;
  };

  _proto10.debug = function debug() {
    if (this.debugLoggingEnabled) {
      var _console;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_console = console).log.apply(_console, ['[consent wrapper debug]'].concat(args));
    }
  };

  _createClass(Logger, [{
    key: "debugLoggingEnabled",
    get: function get() {
      return window['SEGMENT_CONSENT_WRAPPER_DEBUG_MODE'] === true;
    }
  }]);

  return Logger;
}();

var logger = new Logger();

var LoadContext =
/*#__PURE__*/
function () {
  function LoadContext() {
    this.isAbortCalled = false;
    this.isLoadCalled = false;
    this.abortLoadOptions = {
      loadSegmentNormally: true
    };
    this.loadOptions = {
      /**
       * Opt-in consent
       */
      consentModel: 'opt-in'
    };
  }
  /**
   * Allow analytics.js to be initialized with the consent wrapper.
   * Note: load just means 'allowed to load' -- we still wait for analytics.load to be explicitly called.
   */


  var _proto11 = LoadContext.prototype;

  _proto11.load = function load(options) {
    this.isLoadCalled = true;
    this.loadOptions = Object.assign({}, this.loadOptions, options);
    logger.debug('ctx.load called', this.loadOptions);
  }
  /**
   * Abort the _consent-wrapped_ analytics.js initialization
   */
  ;

  _proto11.abort = function abort(options) {
    this.isAbortCalled = true;
    this.abortLoadOptions = Object.assign({}, this.abortLoadOptions, options);
    logger.debug('Abort consent wrapper', this.loadOptions);
  };

  _proto11.validate = function validate() {
    if (this.isAbortCalled && this.isLoadCalled) {
      throw new ValidationError('both abort and load should not be called');
    }
  };

  return LoadContext;
}();
/**
 * Wrapper for shouldLoadSegment fn
 */


var normalizeShouldLoadSegment = function normalizeShouldLoadSegment(shouldLoadSegment) {
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      var loadCtx;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              loadCtx = new LoadContext();
              _context7.next = 3;
              return shouldLoadSegment === null || shouldLoadSegment === void 0 ? void 0 : shouldLoadSegment(loadCtx);

            case 3:
              loadCtx.validate();
              return _context7.abrupt("return", loadCtx);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))
  );
};
/**
 * Return a promise that can be externally resolved
 */


var createDeferred = function createDeferred() {
  var resolve;
  var reject;
  var settled = false;
  var promise = new Promise(function (_resolve, _reject) {
    resolve = function resolve() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      settled = true;

      _resolve.apply(void 0, args);
    };

    reject = function reject() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      settled = true;

      _reject.apply(void 0, args);
    };
  });
  return {
    resolve: resolve,
    reject: reject,
    promise: promise,
    isSettled: function isSettled() {
      return settled;
    }
  };
};
/**
 * Parse list of categories from `cdnSettings.integration.myIntegration` object
 * @example
 * returns ["Analytics", "Advertising"]
 */


var parseConsentCategories = function parseConsentCategories(integration) {
  if (integration && typeof integration === 'object' && 'consentSettings' in integration && typeof integration.consentSettings === 'object' && integration.consentSettings && 'categories' in integration.consentSettings && Array.isArray(integration.consentSettings.categories)) {
    return integration.consentSettings.categories || undefined;
  }

  return undefined;
};

var parseAllCategories = function parseAllCategories(integrationCategoryMappings) {
  return uniq(Object.values(integrationCategoryMappings).reduce(function (p, n) {
    return p.concat(n);
  }));
};
/**
 * @returns whether or not analytics.js should be completely disabled (never load, or drop cookies)
 */


var segmentShouldBeDisabled = function segmentShouldBeDisabled(categories, consentSettings) {
  if (!consentSettings || consentSettings.hasUnmappedDestinations) {
    return false;
  } // disable if _all_ of the the consented categories are irrelevant to segment


  return Object.keys(categories).filter(function (c) {
    return categories[c];
  }).every(function (c) {
    return !consentSettings.allCategories.includes(c);
  });
};

var isIntegrationCategoryEnabled = function isIntegrationCategoryEnabled(categories, userCategories) {
  var isMissingCategories = !categories || !categories.length; // Enable integration by default if it contains no consent categories data (most likely because consent has not been configured).

  if (isMissingCategories) {
    return true;
  } // Enable integration by default if it contains no consent categories data (most likely because consent has not been configured).


  var isEnabled = categories.every(function (c) {
    return userCategories[c];
  });
  return isEnabled;
};

var shouldEnableIntegrationHelper = function shouldEnableIntegrationHelper(creationName, cdnSettings, userCategories, filterSettings) {
  var _ref9;

  if (filterSettings === void 0) {
    filterSettings = {};
  }

  var _filterSettings = filterSettings,
      integrationCategoryMappings = _filterSettings.integrationCategoryMappings,
      shouldEnableIntegration = _filterSettings.shouldEnableIntegration;
  var categories = (_ref9 = integrationCategoryMappings ? integrationCategoryMappings[creationName] : parseConsentCategories(cdnSettings.integrations[creationName])) !== null && _ref9 !== void 0 ? _ref9 : []; // allow user to customize consent logic if needed

  if (shouldEnableIntegration) {
    return shouldEnableIntegration(categories, userCategories, {
      creationName: creationName
    });
  }

  return isIntegrationCategoryEnabled(categories, userCategories);
};
/**
 * For opt-in tracking, ensure that device mode destinations that are not consented to are not loaded at all..
 * This means that the destinations are never loaded. By disabling them here,  they can never drop their own cookies or track users.
 * On the downside, it means that the user will not be able to opt-in to these destinations without a page refresh.
 */


var filterDeviceModeDestinationsForOptIn = function filterDeviceModeDestinationsForOptIn(cdnSettings, consentedCategories, filterSettings) {
  var remotePlugins = cdnSettings.remotePlugins,
      integrations = cdnSettings.integrations;
  var integrationCategoryMappings = filterSettings.integrationCategoryMappings,
      shouldEnableIntegration = filterSettings.shouldEnableIntegration;
  var cdnSettingsCopy = Object.assign({}, cdnSettings, {
    remotePlugins: _toConsumableArray(remotePlugins || []),
    integrations: Object.assign({}, integrations)
  });

  var _shouldEnableIntegrationHelper = function _shouldEnableIntegrationHelper(creationName) {
    return shouldEnableIntegrationHelper(creationName, cdnSettings, consentedCategories, {
      integrationCategoryMappings: integrationCategoryMappings,
      shouldEnableIntegration: shouldEnableIntegration
    });
  };

  var _loop = function _loop(creationName) {
    if (!_shouldEnableIntegrationHelper(creationName)) {
      logger.debug("Disabled (opt-in): " + creationName);
      cdnSettingsCopy.remotePlugins = remotePlugins === null || remotePlugins === void 0 ? void 0 : remotePlugins.filter(function (p) {
        return p.creationName !== creationName;
      }); // remove disabled classic destinations and locally-installed action destinations

      delete cdnSettingsCopy.integrations[creationName];
    } else {
      logger.debug("Enabled (opt-in): " + creationName);
    }
  };

  for (var creationName in integrations) {
    _loop(creationName);
  }

  return cdnSettingsCopy;
}; // Block all device mode destinations


var addBlockingMiddleware = function addBlockingMiddleware(cdnSettingsP, analyticsInstance, filterSettings) {
  var blockDeviceMode =
  /*#__PURE__*/
  function () {
    var _ref11 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(_ref10) {
      var creationName, payload, next, cdnSettings, eventCategoryPreferences, disabled;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              creationName = _ref10.integration, payload = _ref10.payload, next = _ref10.next;
              _context8.next = 3;
              return cdnSettingsP;

            case 3:
              cdnSettings = _context8.sent;
              eventCategoryPreferences = payload.obj.context.consent.categoryPreferences;
              disabled = !shouldEnableIntegrationHelper(creationName, cdnSettings, eventCategoryPreferences, filterSettings);
              logger.debug("Destination middleware called: " + creationName, {
                DROPPED: disabled,
                categoryPreferences: eventCategoryPreferences,
                payload: payload.obj,
                filterSettings: filterSettings
              });

              if (!disabled) {
                _context8.next = 9;
                break;
              }

              return _context8.abrupt("return", null);

            case 9:
              next(payload);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function blockDeviceMode(_x3) {
      return _ref11.apply(this, arguments);
    };
  }();

  analyticsInstance.addDestinationMiddleware('*', blockDeviceMode); // Block segment itself (Segment.io isn't currently allowed in addDestinationMiddleware)

  var blockSegmentAndEverythingElse =
  /*#__PURE__*/
  function () {
    var _ref13 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9(_ref12) {
      var payload, next, cdnSettings, eventCategoryPreferences, consentSettings, disabled;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              payload = _ref12.payload, next = _ref12.next;
              _context9.next = 3;
              return cdnSettingsP;

            case 3:
              cdnSettings = _context9.sent;
              eventCategoryPreferences = payload.obj.context.consent.categoryPreferences;
              consentSettings = filterSettings.integrationCategoryMappings ? {
                hasUnmappedDestinations: false,
                allCategories: parseAllCategories(filterSettings.integrationCategoryMappings)
              } : cdnSettings.consentSettings;
              disabled = segmentShouldBeDisabled(eventCategoryPreferences, consentSettings);
              logger.debug('Source middleware called', {
                DROPPED: disabled,
                categoryPreferences: eventCategoryPreferences,
                payload: payload.obj,
                filterSettings: filterSettings,
                consentSettings: consentSettings
              });

              if (!disabled) {
                _context9.next = 10;
                break;
              }

              return _context9.abrupt("return", null);

            case 10:
              next(payload);

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function blockSegmentAndEverythingElse(_x4) {
      return _ref13.apply(this, arguments);
    };
  }();

  analyticsInstance.addSourceMiddleware(blockSegmentAndEverythingElse);
};
/**
 * Create analytics addSourceMiddleware fn that stamps each event
 */


var createConsentStampingMiddleware = function createConsentStampingMiddleware(getCategories) {
  var fn =
  /*#__PURE__*/
  function () {
    var _ref15 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10(_ref14) {
      var payload, next;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              payload = _ref14.payload, next = _ref14.next;
              _context10.t0 = Object;
              _context10.t1 = {};
              _context10.t2 = payload.obj.context.consent;
              _context10.next = 6;
              return getCategories();

            case 6:
              _context10.t3 = _context10.sent;
              _context10.t4 = {
                categoryPreferences: _context10.t3
              };
              payload.obj.context.consent = _context10.t0.assign.call(_context10.t0, _context10.t1, _context10.t2, _context10.t4);
              next(payload);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function fn(_x5) {
      return _ref15.apply(this, arguments);
    };
  }();

  return fn;
};

var getPrunedCategories = function getPrunedCategories(categories, allCategories) {
  if (!allCategories.length) {
    // No configured integrations found, so no categories will be sent (should not happen unless there's a configuration error)
    throw new ValidationError('Invariant: No consent categories defined in Segment', []);
  }

  return pick(categories, allCategories);
};
/**
 * This class is a wrapper around the analytics.js library.
 */


var AnalyticsService =
/*#__PURE__*/
function () {
  var _proto12 = AnalyticsService.prototype;

  _proto12.getAllCategories =
  /*#__PURE__*/
  function () {
    var _getAllCategories = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11() {
      var _yield$this$cdnSettin;

      var allCategories;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!this.settings.integrationCategoryMappings) {
                _context11.next = 4;
                break;
              }

              _context11.t0 = parseAllCategories(this.settings.integrationCategoryMappings);
              _context11.next = 16;
              break;

            case 4:
              _context11.next = 6;
              return this.cdnSettings;

            case 6:
              _context11.t2 = _yield$this$cdnSettin = _context11.sent.consentSettings;
              _context11.t1 = _context11.t2 === null;

              if (_context11.t1) {
                _context11.next = 10;
                break;
              }

              _context11.t1 = _yield$this$cdnSettin === void 0;

            case 10:
              if (!_context11.t1) {
                _context11.next = 14;
                break;
              }

              _context11.t3 = void 0;
              _context11.next = 15;
              break;

            case 14:
              _context11.t3 = _yield$this$cdnSettin.allCategories;

            case 15:
              _context11.t0 = _context11.t3;

            case 16:
              allCategories = _context11.t0;
              return _context11.abrupt("return", allCategories !== null && allCategories !== void 0 ? allCategories : []);

            case 18:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getAllCategories() {
      return _getAllCategories.apply(this, arguments);
    }

    return getAllCategories;
  }();

  _proto12.getCategories =
  /*#__PURE__*/
  function () {
    var _getCategories = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12() {
      var categories;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.settings.getCategories();

            case 2:
              categories = _context12.sent;
              validateCategories(categories);
              return _context12.abrupt("return", categories);

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getCategories() {
      return _getCategories.apply(this, arguments);
    }

    return getCategories;
  }();

  function AnalyticsService(analytics, options) {
    this.cdnSettingsDeferred = createDeferred();
    /**
     * Allow for gracefully passing a custom disable function (without clobbering the default behavior)
     */

    this.createDisableOption = function (categories, disable) {
      if (disable === true) {
        return true;
      }

      return function (cdnSettings) {
        return segmentShouldBeDisabled(categories, cdnSettings.consentSettings) || (typeof disable === 'function' ? disable(cdnSettings) : false);
      };
    };

    validateAnalyticsInstance(analytics);
    this.settings = options;
    this.uninitializedAnalytics = analytics;
    this.ogAnalyticsLoad = analytics.load.bind(analytics);
  }

  _proto12.loadWithFilteredDeviceModeDestinations =
  /*#__PURE__*/
  function () {
    var _loadWithFilteredDeviceModeDestinations = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13() {
      var _this12 = this,
          _options$updateCDNSet;

      var _len4,
          _ref16,
          _key4,
          settings,
          options,
          initialCategories,
          _filterDeviceModeDestinationsForOptIn,
          _args13 = arguments;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              for (_len4 = _args13.length, _ref16 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                _ref16[_key4] = _args13[_key4];
              }

              settings = _ref16[0], options = _ref16[1];
              _context13.next = 4;
              return this.getCategories();

            case 4:
              initialCategories = _context13.sent;

              _filterDeviceModeDestinationsForOptIn = function _filterDeviceModeDestinationsForOptIn(cdnSettings) {
                return filterDeviceModeDestinationsForOptIn(cdnSettings, initialCategories, {
                  shouldEnableIntegration: _this12.settings.shouldEnableIntegration,
                  integrationCategoryMappings: _this12.settings.integrationCategoryMappings
                });
              };

              return _context13.abrupt("return", this.load(settings, Object.assign({}, options, {
                updateCDNSettings: pipe(_filterDeviceModeDestinationsForOptIn, (_options$updateCDNSet = options === null || options === void 0 ? void 0 : options.updateCDNSettings) !== null && _options$updateCDNSet !== void 0 ? _options$updateCDNSet : function (id) {
                  return id;
                }),
                disable: this.createDisableOption(initialCategories, options === null || options === void 0 ? void 0 : options.disable)
              })));

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function loadWithFilteredDeviceModeDestinations() {
      return _loadWithFilteredDeviceModeDestinations.apply(this, arguments);
    }

    return loadWithFilteredDeviceModeDestinations;
  }()
  /**
   * The orignal analytics load function, but also stores the CDN settings on the instance.
   */
  ;

  _proto12.load = function load() {
    var _this13 = this;

    for (var _len5 = arguments.length, _ref17 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      _ref17[_key5] = arguments[_key5];
    }

    var settings = _ref17[0],
        options = _ref17[1];
    return this.ogAnalyticsLoad(settings, Object.assign({}, options, {
      updateCDNSettings: pipe((options === null || options === void 0 ? void 0 : options.updateCDNSettings) || function (id) {
        return id;
      }, function (cdnSettings) {
        logger.debug('CDN settings loaded', cdnSettings); // extract the CDN settings from this call and store it on the instance.

        _this13.cdnSettingsDeferred.resolve(cdnSettings);

        return cdnSettings;
      })
    }));
  }
  /**
   * Replace the load fn with a new one
   */
  ;

  _proto12.replaceLoadMethod = function replaceLoadMethod(loadFn) {
    this.analytics.load = loadFn;
  };

  _proto12.page = function page() {
    this.analytics.page();
  };

  _proto12.configureBlockingMiddlewareForOptOut = function configureBlockingMiddlewareForOptOut() {
    addBlockingMiddleware(this.cdnSettings, this.analytics, {
      integrationCategoryMappings: this.settings.integrationCategoryMappings,
      shouldEnableIntegration: this.settings.shouldEnableIntegration
    });
  };

  _proto12.configureConsentStampingMiddleware = function configureConsentStampingMiddleware() {
    var _this14 = this;

    var pruneUnmappedCategories = this.settings.pruneUnmappedCategories; // normalize getCategories pruning is turned on or off

    var getCategoriesForConsentStamping =
    /*#__PURE__*/
    function () {
      var _ref18 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var categories;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this14.getCategories();

              case 2:
                categories = _context14.sent;

                if (!pruneUnmappedCategories) {
                  _context14.next = 10;
                  break;
                }

                _context14.t0 = getPrunedCategories;
                _context14.t1 = categories;
                _context14.next = 8;
                return _this14.getAllCategories();

              case 8:
                _context14.t2 = _context14.sent;
                return _context14.abrupt("return", (0, _context14.t0)(_context14.t1, _context14.t2));

              case 10:
                return _context14.abrupt("return", categories);

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function getCategoriesForConsentStamping() {
        return _ref18.apply(this, arguments);
      };
    }();

    var MW = createConsentStampingMiddleware(getCategoriesForConsentStamping);
    this.analytics.addSourceMiddleware(MW);
  }
  /**
   * Dispatch an event that looks like:
   * ```ts
   * {
   * "type": "track",
   *  "event": "Segment Consent Preference Updated",
   *  "context": {
   *    "consent": {
   *      "categoryPreferences" : {
   *         "C0001": true,
   *         "C0002": false,
   *    }
   *  }
   * ...
   * ```
   */
  ;

  _proto12.consentChange = function consentChange(categories) {
    logger.debug('Consent change', categories);

    try {
      validateCategories(categories);
    } catch (e) {
      // not sure if there's a better way to handle this
      return console.error(e);
    }

    var CONSENT_CHANGED_EVENT = 'Segment Consent Preference Updated';
    this.analytics.track(CONSENT_CHANGED_EVENT, undefined, {
      consent: {
        categoryPreferences: categories
      }
    });
  };

  _createClass(AnalyticsService, [{
    key: "analytics",
    get: function get() {
      return getInitializedAnalytics(this.uninitializedAnalytics);
    }
  }, {
    key: "cdnSettings",
    get: function get() {
      return this.cdnSettingsDeferred.promise;
    }
  }]);

  return AnalyticsService;
}();
/**
 * Get possibly-initialized analytics.
 *
 * Reason:
 * There is a known bug for people who attempt to to wrap the library: the analytics reference does not get updated when the analytics.js library loads.
 * Thus, we need to proxy events to the global reference instead.
 *
 * There is a universal fix here: however, many users may not have updated it:
 * https://github.com/segmentio/snippet/commit/081faba8abab0b2c3ec840b685c4ff6d6cccf79c
 */


var getInitializedAnalytics = function getInitializedAnalytics(analytics) {
  var isSnippetUser = Array.isArray(analytics);

  if (isSnippetUser) {
    var _analytics$_loadOptio, _opts$globalAnalytics;

    var opts = (_analytics$_loadOptio = analytics._loadOptions) !== null && _analytics$_loadOptio !== void 0 ? _analytics$_loadOptio : {};
    var globalAnalytics = window[(_opts$globalAnalytics = opts === null || opts === void 0 ? void 0 : opts.globalAnalyticsKey) !== null && _opts$globalAnalytics !== void 0 ? _opts$globalAnalytics : 'analytics']; // we could probably skip this check and always return globalAnalytics, since they _should_ be set to the same thing at this point
    // however, it is safer to keep buffering.

    if (globalAnalytics !== null && globalAnalytics !== void 0 && globalAnalytics.initialized) {
      return globalAnalytics;
    }
  }

  return analytics;
};

var createWrapper = function createWrapper() {
  for (var _len6 = arguments.length, _ref19 = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    _ref19[_key6] = arguments[_key6];
  }

  var createWrapperSettings = _ref19[0];
  validateSettings(createWrapperSettings);
  var shouldDisableSegment = createWrapperSettings.shouldDisableSegment,
      getCategories = createWrapperSettings.getCategories,
      shouldLoadSegment = createWrapperSettings.shouldLoadSegment,
      integrationCategoryMappings = createWrapperSettings.integrationCategoryMappings,
      shouldEnableIntegration = createWrapperSettings.shouldEnableIntegration,
      registerOnConsentChanged = createWrapperSettings.registerOnConsentChanged,
      shouldLoadWrapper = createWrapperSettings.shouldLoadWrapper,
      enableDebugLogging = createWrapperSettings.enableDebugLogging;
  return function (analytics) {
    var analyticsService = new AnalyticsService(analytics, {
      integrationCategoryMappings: integrationCategoryMappings,
      shouldEnableIntegration: shouldEnableIntegration,
      getCategories: getCategories
    });

    if (enableDebugLogging) {
      logger.enableDebugLogging();
    }

    var loadWrapper = (shouldLoadWrapper === null || shouldLoadWrapper === void 0 ? void 0 : shouldLoadWrapper()) || Promise.resolve();
    void loadWrapper.then(function () {
      // Call this function as early as possible. OnConsentChanged events can happen before .load is called.
      registerOnConsentChanged === null || registerOnConsentChanged === void 0 ? void 0 : registerOnConsentChanged(function (categories) {
        return (// whenever consent changes, dispatch a new event with the latest consent information
          analyticsService.consentChange(categories)
        );
      });
    }); // Create new load method to handle consent that will replace the original on the analytics instance

    var loadWithConsent =
    /*#__PURE__*/
    function () {
      var _ref20 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(settings, options) {
        var _options;

        var loadCtx, _loadCtx$abortLoadOpt;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                // Prevent stale page context by handling initialPageview ourself.
                // By calling page() here early, the current page context (url, etc) gets stored in the pre-init buffer.
                // We then set initialPageView to false when we call the underlying analytics library, so page() doesn't get called twice.
                if ((_options = options) !== null && _options !== void 0 && _options.initialPageview) {
                  analyticsService.page();
                  options = Object.assign({}, options, {
                    initialPageview: false
                  });
                } // do not load anything -- segment included


                _context15.next = 3;
                return shouldDisableSegment === null || shouldDisableSegment === void 0 ? void 0 : shouldDisableSegment();

              case 3:
                if (!_context15.sent) {
                  _context15.next = 5;
                  break;
                }

                return _context15.abrupt("return");

              case 5:
                _context15.next = 7;
                return loadWrapper;

              case 7:
                _context15.next = 9;
                return normalizeShouldLoadSegment(shouldLoadSegment)();

              case 9:
                loadCtx = _context15.sent;

                if (!loadCtx.isAbortCalled) {
                  _context15.next = 13;
                  break;
                }

                if (((_loadCtx$abortLoadOpt = loadCtx.abortLoadOptions) === null || _loadCtx$abortLoadOpt === void 0 ? void 0 : _loadCtx$abortLoadOpt.loadSegmentNormally) === true) {
                  analyticsService.load(settings, options);
                }

                return _context15.abrupt("return", undefined);

              case 13:
                // register listener to stamp all events with latest consent information
                analyticsService.configureConsentStampingMiddleware(); // if opt-out, we load as usual and then rely on the consent blocking middleware to block events
                // if opt-in, we remove all destinations that are not explicitly consented to so they never load in the first place

                if (!(loadCtx.loadOptions.consentModel === 'opt-in')) {
                  _context15.next = 20;
                  break;
                }

                _context15.next = 17;
                return analyticsService.loadWithFilteredDeviceModeDestinations(settings, options);

              case 17:
                return _context15.abrupt("return", undefined);

              case 20:
                if (!(loadCtx.loadOptions.consentModel === 'opt-out')) {
                  _context15.next = 26;
                  break;
                }

                analyticsService.configureBlockingMiddlewareForOptOut();
                analyticsService.load(settings, options);
                return _context15.abrupt("return", undefined);

              case 26:
                // for typescript exhaustiveness
                assertNever(loadCtx.loadOptions.consentModel);

              case 27:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function loadWithConsent(_x6, _x7) {
        return _ref20.apply(this, arguments);
      };
    }();

    analyticsService.replaceLoadMethod(loadWithConsent);
    return analytics;
  };
};

var CookieScriptEvents;

(function (CookieScriptEvents) {
  // Fires when the visitor accepts all cookies used on the website, no matter if you use cookie categories or not.
  CookieScriptEvents["CookieScriptAcceptAll"] = "CookieScriptAcceptAll"; // Fires when visitor accepts some cookie categories, only fires when cookie categories are used.
  // Accepted categories are passed together with events (see example below).

  CookieScriptEvents["CookieScriptAccept"] = "CookieScriptAccept"; // Fires when the visitor rejects all cookies, no matter if cookie categories are used or not.

  CookieScriptEvents["CookieScriptReject"] = "CookieScriptReject"; // Fires when the visitor closes the cookie consent banner.

  CookieScriptEvents["CookieScriptClose"] = "CookieScriptClose"; // Fires when CookieScript.Instance is ready and its functions are available to use.

  CookieScriptEvents["CookieScriptLoaded"] = "CookieScriptLoaded"; // Fires if the user agreed to Functionality cookies.

  CookieScriptEvents["CookieScriptCategoryFunctionality"] = "CookieScriptCategory-functionality"; // Fires if the user agreed to Strictly necessary cookies.

  CookieScriptEvents["CookieScriptCategoryStrict"] = "CookieScriptCategory-strict"; // Fires if the user agreed to Targeting cookies.

  CookieScriptEvents["CookieScriptCategoryTargeting"] = "CookieScriptCategory-targeting"; // Fires if the user agreed to Performance cookies.

  CookieScriptEvents["CookieScriptCategoryPerformance"] = "CookieScriptCategory-performance"; // Fires if the user agreed to Unclassified cookies.

  CookieScriptEvents["CookieScriptCategoryUnclassified"] = "CookieScriptCategory-unclassified";
})(CookieScriptEvents || (CookieScriptEvents = {}));

var CookieScriptWindowObject = 'CookieScript'; // The global variable created by CookieScript

var OptOutCountries = ['au', 'ci', 'gi', 'hk', 'in', 'jp', 'my', 'mx', 'nz', 'no', 'sg', 'ch', 'ae', 'gh', 'id', 'ke', 'li', 'ng', 'za', 'th'];
var OptOutStates = ['al', 'ak', 'az', 'ar', 'co', 'ct', 'de', 'fl', 'ga', 'hi', 'id', 'il', 'in', 'ia', 'ks', 'ky', 'la', 'me', 'md', 'ma', 'mi', 'mn', 'ms', 'mo', 'mt', 'ne', 'nv', 'nh', 'nj', 'nm', 'ny', 'nc', 'nd', 'oh', 'ok', 'or', 'pa', 'ri', 'sc', 'sd', 'tn', 'tx', 'ut', 'vt', 'va', 'wa', 'wv', 'wi', 'wy'];
var OptInCountries = ['ca', 'gb'];
var OptInStates = ['ca'];
var OptInRegions = ['eu'];

var CookieScriptConsentManager = function CookieScriptConsentManager(window, bannerIds) {
  var _this15 = this;

  var _a;

  this.getConsentModel = function () {
    // Default to strictest opt-in consent model when banner is unknown.
    return _this15.getCookieScriptInstance().hash() === _this15.optOutBannerId ? 'opt-out' : 'opt-in';
  };

  this.getCategories = function () {
    var consentedCategories = _this15.getCookieScriptInstance().currentState().categories;

    return _this15.mapConsentCategories(consentedCategories);
  };

  this.onConsentChanged = function (setCategories) {
    _this15.registerAcceptAllEventListener(setCategories);

    _this15.registerAcceptEventListener(setCategories);

    _this15.registerRejectEventListener(setCategories);
  };

  this.getCookieScriptInstance = function () {
    var _a;

    return (_a = _this15.window[CookieScriptWindowObject]) === null || _a === void 0 ? void 0 : _a.instance;
  };

  this.isKnownBanner = function (bannerId) {
    return bannerId === _this15.optInBannerId || bannerId === _this15.optOutBannerId;
  };

  this.registerAcceptAllEventListener = function (setCategories) {
    _this15.window.addEventListener(CookieScriptEvents.CookieScriptAcceptAll, function () {
      var categories = _this15.mapConsentCategories(['strict', 'performance', 'targeting', 'functionality']);

      setCategories(categories);
    });
  };

  this.registerAcceptEventListener = function (setCategories) {
    _this15.window.addEventListener(CookieScriptEvents.CookieScriptAccept, function (e) {
      // e.detail will include this data:
      // { categories: ['strict', 'functionality'] }
      var categories = _this15.mapConsentCategories(e.detail.categories, true);

      setCategories(categories);
    }, false);
  };

  this.registerRejectEventListener = function (setCategories) {
    _this15.window.addEventListener(CookieScriptEvents.CookieScriptReject, function () {
      setCategories(_this15.mapConsentCategories([], true));
    });
  };

  this.mapConsentCategories = function (categories, hasConsentChanged) {
    if (hasConsentChanged === void 0) {
      hasConsentChanged = false;
    }

    var _a;

    var consentModel = _this15.getConsentModel(); // if consent exist or consent changed, we don't want to alter the categories
    // Otherwise we need to alter them to patch for CookieScript's missing categories


    var cookieScriptInstance = _this15.getCookieScriptInstance();

    var hasExistingConsent = (_a = cookieScriptInstance.currentState().action) !== null && _a !== void 0 ? _a : false;

    if (consentModel === 'opt-out' && !hasConsentChanged && !hasExistingConsent) {
      return _this15.mapOptOutCategories();
    }

    return _this15.mapCategories(categories);
  };

  this.mapOptOutCategories = function () {
    // need to add categories to the consented array because CookieScript doesn't return them all
    return _this15.mapCategories(['strict', 'performance', 'targeting', 'functionality']);
  };

  this.mapCategories = function (categories) {
    return categories.reduce(function (consentedCategories, category) {
      if (category !== 'unclassified') {
        consentedCategories[category] = true;
      }

      return consentedCategories;
    }, {});
  };

  var instance = (_a = window[CookieScriptWindowObject]) === null || _a === void 0 ? void 0 : _a.instance;
  this.window = window;
  this.optInBannerId = bannerIds.optInBannerId;
  this.optOutBannerId = bannerIds.optOutBannerId;

  if (!instance || !this.isKnownBanner(instance.hash())) {
    throw new Error('CookieScript global object is not defined');
  }
};

var StrictlyNecessaryCategories = {
  strict: true,
  performance: false,
  targeting: false,
  functionality: false
};

var StrictConsentManager = function StrictConsentManager() {
  this.getConsentModel = function () {
    // Default to strictest opt-in consent model.
    return 'opt-in';
  };

  this.getCategories = function () {
    return StrictlyNecessaryCategories;
  };

  this.onConsentChanged = function (setCategories) {
    setCategories(StrictlyNecessaryCategories);
  };
};

var CookieScriptSegmentWrapper = function CookieScriptSegmentWrapper(config) {
  var _this16 = this;

  var _a, _b;

  this.shouldLoadWrapper = function () {
    return __awaiter(_this16, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee16() {
      var _this17 = this;

      var initializationAttempts;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!this.consentManager) {
                _context16.next = 2;
                break;
              }

              return _context16.abrupt("return");

            case 2:
              initializationAttempts = 0;
              _context16.next = 5;
              return resolveWhen(function () {
                try {
                  // 5 attempts =< 2.5 seconds
                  if (initializationAttempts < 5) {
                    var manager = new CookieScriptConsentManager(window, {
                      optInBannerId: _this17.optInBannerId,
                      optOutBannerId: _this17.optOutBannerId
                    });
                    _this17.consentManager = manager;
                  } else {
                    // Fallback to strict consent manager if CookieScript is not available
                    var _manager = new StrictConsentManager();

                    _this17.consentManager = _manager;
                  }

                  return true;
                } catch (_a) {
                  return false;
                } finally {
                  initializationAttempts = initializationAttempts + 1;
                }
              }, this.retryIntervalInMS);

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));
  };

  this.shouldLoadSegment = function (ctx) {
    var consentModel = _this16.consentManager.getConsentModel(); // Load Segment with the consent model.
    // We load it instantly because we want it to load all allowed scripts like Google tags manager.


    return ctx.load({
      consentModel: consentModel
    });
  };

  this.getCategories = function () {
    return _this16.consentManager.getCategories();
  };

  this.registerOnConsentChanged = function (setCategories) {
    _this16.consentManager.onConsentChanged(setCategories);
  };

  this.optInBannerId = config.optInBannerId;
  this.optOutBannerId = config.optOutBannerId;
  this.enableDebugLogging = (_a = config.enableDebugLogging) !== null && _a !== void 0 ? _a : false;
  this.retryIntervalInMS = (_b = config.retryIntervalInMS) !== null && _b !== void 0 ? _b : 500; // Default to 500ms if not provided
};

CookieScriptSegmentWrapper.createCookieScriptWrapper = function (_ref21) {
  var optInBannerId = _ref21.optInBannerId,
      optOutBannerId = _ref21.optOutBannerId,
      enableDebugLogging = _ref21.enableDebugLogging;
  var cookieScriptsegmentWrapper = new CookieScriptSegmentWrapper({
    optInBannerId: optInBannerId,
    optOutBannerId: optOutBannerId,
    enableDebugLogging: enableDebugLogging
  });
  return createWrapper({
    enableDebugLogging: cookieScriptsegmentWrapper.enableDebugLogging,
    // Wait to load wrapper until CookieScript is defined
    shouldLoadWrapper: cookieScriptsegmentWrapper.shouldLoadWrapper,
    // Allow for control over wrapper + analytics initialization.
    shouldLoadSegment: cookieScriptsegmentWrapper.shouldLoadSegment,
    getCategories: cookieScriptsegmentWrapper.getCategories,
    registerOnConsentChanged: cookieScriptsegmentWrapper.registerOnConsentChanged
  });
};

var CookieScriptGeoLocationDomain = 'https://geo.cookie-script.com/s/';

var CookieScriptBannerLoader =
/*#__PURE__*/
function () {
  function CookieScriptBannerLoader(bannerIds) {
    this.optInBannerId = bannerIds.optInBannerId;
    this.optOutBannerId = bannerIds.optOutBannerId;
  }

  var _proto13 = CookieScriptBannerLoader.prototype;

  _proto13.loadBanner = function loadBanner() {
    var scriptLoader = new ScriptLoader();
    return void scriptLoader.loadScripts([this.getOptOutBannerUrl(), this.getOptInBannerUrl()]);
  };

  _proto13.getOptOutBannerUrl = function getOptOutBannerUrl() {
    return "" + CookieScriptGeoLocationDomain + this.optOutBannerId + ".js?" + this.getGeoLocationOptOutConfig();
  };

  _proto13.getOptInBannerUrl = function getOptInBannerUrl() {
    return "" + CookieScriptGeoLocationDomain + this.optInBannerId + ".js?" + this.getGeoLocationOptInConfig();
  };

  _proto13.getGeoLocationOptOutConfig = function getGeoLocationOptOutConfig() {
    var searchParams = new URLSearchParams(); // country=au-hk-jp-mx

    var optOutCountries = OptOutCountries.join('-');
    searchParams.set('country', optOutCountries); // US States
    // state=al-az

    var optOutStates = OptOutStates.join('-');
    searchParams.set('state', optOutStates);
    return searchParams.toString();
  };

  _proto13.getGeoLocationOptInConfig = function getGeoLocationOptInConfig() {
    var searchParams = new URLSearchParams(); // country=au-hk-jp-mx

    var optInCountries = OptInCountries.join('-');
    searchParams.set('country', optInCountries); // US States
    // state=al-az

    var optInStates = OptInStates.join('-');
    searchParams.set('state', optInStates);
    var optInRegions = OptInRegions.join('-');
    searchParams.set('region', optInRegions);
    return searchParams.toString();
  };

  return CookieScriptBannerLoader;
}();

export { AbstractSegmentService, AbstractSegmentServiceV2, AnalyticsApplication, AnalyticsPlatformName, ApplicationEnum, BrowserLogger, CommonEventIds, ConsoleLogService, ConvertExperimentLoader, CookieScriptBannerLoader, CookieScriptSegmentWrapper, DefaultLanguage, DesktopAppEvents, DollarSignCurrenciesEnum, InternalErrorEnum, LandrEventType, Languages, Locales, LogLevel, LogService, LogglyService, MfeApplicationEnum, ProjectPageQueryParams, ProjectsCallSourceTypesEnum, ScriptLoader, SegmentLoader, SubscriptionServiceOfferEnum, TransformMethods, ZeroDecimalCurrenciesEnum, addLandrEventListener, areDevToolsActive, broadcastLandrEvent, convertLocale, convertToPascalCase, extractFirstLetterAsUppercase, fetchWithCommonHeaders, fetchWithRetries, filterErrorFields, filterUnallowedExtraInfosFields, getAnonymousId, getAssetsUri, getBlogLink, getCachedAppConfig, getCachedForcedFlags, getChromaticLink, getEducationLink, getEnvDomain, getEnvSuffix, getError, getGoogleAnalyticsClientId, getGraphqlHttpUri, getGraphqlWsUri, getGuestSiteLink, getInitials, getInitialsFromFullName, getLogLevel, getLogLevelForError, getMsApiUri, getNetworkLink, getOfflineConversion, getPlatformName, getPrivacyPolicyRootLink, getRealLogLevel, getRedeemAProductLink, getRootApiUri, getSameOriginLink, getSamplesLink, getSessionsLink, getSessionsRoomLink, getStudioAILink, getSupportLink, getTermsOfServiceRootLink, getUTMsParams, getWebAppLink, getXLandrAnalytics, getXLandrAnalyticsV2, initCalmResizeObserver, isClassLogEnable, isDesktopApp, isStructuredEvent, listeners, mockBuilder, networkMainAppPrefix, openEducationLink, openGuestSiteLink, openLink, openNetworkLink, openRedeemAProductLink, openSamplesLink, openSessionsLink, openStudioAILink, openSupportLink, openWebAppHomeLink, openWebAppLink, prepareEvent, sanitizeForPath, saveOfflineConversionToCookies, saveUTMsToCookies, sendToDevTools, setupLandrDevTools, shouldLogToProvider, slugifyText, subscribeFromDevTools, supportedOfflineConversionParams, supportedUTMParams, waitForPromises };